import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { GetEstadisticasEvolucionEnAPI, GetEstadisticasEnAPI, GetEjerciciosCSVEnAPI, GetEstadisticasAnyosEnAPI, GetMarcasCSVEnAPI, GetFamiliaCSVEnAPI, GetEstadisticasTecnicoEnAPI, GetEstadisticasRankingEnAPI, GetNextAssistBODepartamentosEnAPI, GetTiposTareaCSVEnAPI, GetCSVEnAPI, GetEstadisticasNextAssistTecnicoNivelEnAPI, GetEstadisticasEvolucionMesDetalleEnAPI, abortFetch, GetEstadisticasTecnicoSatisfaccionEnAPI } from "../../action/actionCreatorsRequests"
import { traducirPagina, convertirAMesACodigo, obtenerFechaLocalObjeto, convertirCodigoAMeses, obtenerUsuario, convertirImporte, colorHEX, dynamicSortAsc, construirFecha, CodigoAMeses, obtenerDiasMes, descargarDocPasandoBase64Generico, dynamicSortDesc } from '../../librerias/funciones'
import { MDBDropdownMenu, MDBDropdown, MDBDropdownToggle, MDBDropdownItem } from 'mdbreact';
import FichaDetalleConsumo from '../../components/FichaDetalleConsumo';
import FichaHistoricoSocio from './FichaHistoricoSocio';
import FichaTecnicoProductivo from './FichaTecnicoProductivo';
import { FichaDetalleMarca } from './FichaDetalleMarca';
import {
    BarChartOutlined,
    EyeOutlined,
    FileExcelOutlined,
    TableOutlined,
    MobileOutlined,
    DesktopOutlined,
    CustomerServiceOutlined,
    ArrowDownOutlined,
    ArrowUpOutlined,
    CloseOutlined
} from '@ant-design/icons';

import { Select, Col, Drawer, Checkbox, Tabs } from 'antd';



import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,

} from "recharts";


const { Option } = Select;
const { TabPane } = Tabs;


const FichaEstadisticaAssist = ({ props, usuario }) => {
    const [tabPorDefecto, setTabPorDefecto] = React.useState("1");
    const [marcaDetalle, setMarcaDetalle] = React.useState(false);
    const [registroMarcaDetalle, setRegistroMarcaDetalle] = React.useState({});


    const [filtroMarca, setFiltroMarca] = React.useState({
        ORDER_DIR: "D",
        ID_CABECERA: -1,
        ACTIVO: false
    });



    const [TAB_SELECCIONADO, setTAB_SELECCIONADO] = React.useState("tab-1");
    const [hayRegristros, setHayRegristros] = React.useState(false);
    const [abrirDetalleTareaTecnico, setAbrirDetalleTareaTecnico] = React.useState(false);
    const [registroDetalleTareaTecnico, setRegistroDetalleTareaTecnico] = React.useState({});
    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);
    const [abrirFichaEstadistica, setAbrirFichaEstadistica] = React.useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = React.useState({});

    const [mesesDelAnio, setMesesDelAnio] = React.useState(
        [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
            "Todos"
        ]
    );

    const [anios, setAnios] = React.useState([]);

    const [filtroFecha, setFiltroFecha] = React.useState({
        CAMBIO_DIA: true,
        CAMBIO_MES: true,
        CAMBIO_ANIO: true,
        CAMBIO_CALENDARIO: false,
        ACCION_DESDE: 4,
        ACCION_HASTA: 5,
        FECHA_PARTIDA: "",

        DIA_SELECCIONADO: 0,
        NUMERO_MES_SELECCIONADO: 0,

        MES_SELECCIONADO: "",
        ANYO_SELECCIONADO: "",
        ID_DEPARTAMENTO: ""
    });



    const [abrirDetalleConsumo, setAbrirDetalleConsumo] = React.useState(false);
    const [tipoConsumo, setTipoConsumo] = React.useState("centro");
    const [tipoGrafico, setTipoGrafico] = React.useState("GRAFICO");
    const [registroKeyGrafico, setRegistroKeyGrafico] = React.useState([]);

    const [tipoVista, setTipoVista] = React.useState(
        {
            GLOBALES: true,
            EVOLUCION: false,
            TECNICO: false,
            RANKING: false,
            PRIORIDAD: false,
            TOTALES: false,
            FEEDBACK: false

        }
    );

    const [feed_back, setFeed_back] = React.useState({
        REGISTROS_GRADO_SATISFACCION: [],
        REGISTROS_TAREA: [],
        REGISTROS_TECNICO_SATISFACCION: []
    })


    const [estadisticas, setEstadisticas] = React.useState({
        EJERCICIOS: [],
        CONSULTAS: [],
        TALLERES: [],
        VOLUMEN_HORAS: [],
        MARCAS: [],
        FAMILIAS: [],
        TECNICOS: [],

        FAMILIAS_RANKING: [],
        MARCAS_RANKING: [],
        MARCAS_MODELO: [],
        TALLERES_EVOLUCION: [],
        TIPO_TAREA: [],
        CODIGO_MOTOR: [],
        TALLERES_RANKING: [],
        PRIORIDAD: [],
        PRIORIDAD_DEPARTAMENTO: [],
        TOTALES: []

    });

    const [departamentos, setDepartamentos] = React.useState([]);


    const GetNextAssistBODepartamentos = (ORDERCOLUM, ORDERDIR, ID, NOMBRE) => {
        GetNextAssistBODepartamentosEnAPI(10000, 1, ORDERCOLUM, ORDERDIR, ID, NOMBRE).then((licencias) => {
            if (licencias !== undefined) {
                if (licencias.REGISTROS !== null && licencias.REGISTROS.length > 0) {
                    let { DEPARTAMENTOS } = obtenerUsuario();
                    if (DEPARTAMENTOS.length > 0) {
                        let DEPA = [];
                        licencias.REGISTROS.map((registro) => {
                            let BUSCAR_DEPA = DEPARTAMENTOS.find((item) => item.ID_DEPARTAMENTO === registro.ID)
                            if (BUSCAR_DEPA !== undefined) {
                                DEPA.push(registro)
                            }
                        })

                        setDepartamentos(DEPA);
                    } else {
                        setDepartamentos(licencias.REGISTROS);
                    }
                } else {
                    setDepartamentos(null)
                }
            }
        })

    }



    const obtenerAnyosEjercicios = (registros) => {
        let ANYOS = [];
        if (registros !== undefined && registros !== null) {
            registros.map((item) => {
                let resultado = ANYOS.find((registro, i) => registro === item.ANYO)
                if (resultado === undefined) {
                    ANYOS.push(item.ANYO)
                }
            })

        }


        return ANYOS;
    }

    const actualizarRegistroAnyoGrafico = (ANYOS) => {

        let ANYOS_GRAFICO = [];

        ANYOS.map((registro,) => {
            ANYOS_GRAFICO.push({ NOMBRE: registro, ACTIVO: true, COLOR: colorHEX(), ANYO: registro })
        })

        ANYOS_GRAFICO.sort(dynamicSortAsc("ANYO"))
        setRegistroKeyGrafico(ANYOS_GRAFICO)
    }


    const GetEstadisticas = (ID_SOCIO, MES, ANYO, ID_DEPARTAMENTO) => {
        setEstadisticas({
            EJERCICIOS: [],
            CONSULTAS: [],
            TALLERES: [],
            VOLUMEN_HORAS: [],
            MARCAS: [],
            FAMILIAS: [],
            TECNICOS: [],

            FAMILIAS_RANKING: [],
            MARCAS_RANKING: [],
            MARCAS_MODELO: [],
            TALLERES_EVOLUCION: [],
            TIPO_TAREA: [],
            CODIGO_MOTOR: [],
            TALLERES_RANKING: [],
            PRIORIDAD: [],
            PRIORIDAD_DEPARTAMENTO: [],

            TOTALES: []
        });

        GetEstadisticasEnAPI(ID_SOCIO, parseInt(MES), ANYO, ID_DEPARTAMENTO).then((licencia) => {
            const { TOTALES, EJERCICIOS, TALLERES, VOLUMEN_HORAS } = licencia;
            estadisticas.CONSULTAS = TOTALES;
            estadisticas.TALLERES = TALLERES;
            estadisticas.VOLUMEN_HORAS = VOLUMEN_HORAS;
            setEstadisticas({ ...estadisticas })


        })
    }


    const GetEstadisticasEvolucion = async (ID_SOCIO, ID_DEPARTAMENTO) => {
        estadisticas.EJERCICIOS = [];
        estadisticas.MARCAS = [];
        estadisticas.FAMILIAS = [];
        estadisticas.TALLERES_EVOLUCION = [];
        estadisticas.TIPO_TAREA = [];

        setEstadisticas({ ...estadisticas });


        const licencia = await GetEstadisticasEvolucionEnAPI(ID_SOCIO, ID_DEPARTAMENTO);


        if (licencia !== undefined && licencia !== null && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {

            let ANYOS = obtenerAnyosEjercicios(licencia.TALLERES);
            actualizarRegistroAnyoGrafico(ANYOS)


            estadisticas.EJERCICIOS = licencia.REGISTROS;
            estadisticas.MARCAS = licencia.MARCAS;
            estadisticas.FAMILIAS = licencia.FAMILIAS;
            estadisticas.TALLERES_EVOLUCION = licencia.TALLERES;
            estadisticas.TIPO_TAREA = licencia.TIPOS_TAREA;

            setEstadisticas({ ...estadisticas });
        } else {
            estadisticas.EJERCICIOS = null;
            estadisticas.MARCAS = null;
            estadisticas.FAMILIAS = null;
            estadisticas.TALLERES_EVOLUCION = null;
            estadisticas.TIPO_TAREA = null;
            setEstadisticas({ ...estadisticas });

        }

        return estadisticas
    }



    const GetEstadisticasTecnico = (ID_SOCIO, MES, ANYO, ID_DEPARTAMENTO, DIA) => {
        estadisticas.TECNICOS = [];
        setEstadisticas({ ...estadisticas });

        GetEstadisticasTecnicoEnAPI(ID_SOCIO, MES, ANYO, ID_DEPARTAMENTO, DIA).then((licencia) => {
            if (licencia !== undefined && licencia !== null && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {
                //let ANYOS = obtenerAnyosEjercicios(licencia.REGISTROS);
                //actualizarRegistroAnyoGrafico(ANYOS)


                estadisticas.TECNICOS = licencia.REGISTROS;
                setEstadisticas({ ...estadisticas });
            } else {
                estadisticas.TECNICOS = null;
                setEstadisticas({ ...estadisticas });
            }
        })
    }




    const GetEstadisticasEvolucionMesDetalle = (ID_SOCIO, ID_DEPARTAMENTO, DIA, MES, ANYO) => {
        estadisticas.TOTALES = [];
        setEstadisticas({ ...estadisticas });
        abortFetch()

        GetEstadisticasEvolucionMesDetalleEnAPI(ID_SOCIO, ID_DEPARTAMENTO, DIA, MES, ANYO).then((licencia) => {


            if (licencia !== undefined && licencia !== null && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {

                estadisticas.TOTALES = licencia.REGISTROS;
                setEstadisticas({ ...estadisticas });
            } else {
                estadisticas.TOTALES = null;
                setEstadisticas({ ...estadisticas });
            }

        })
    }



    const GetEstadisticasRanking = (ID_SOCIO, MES, ANYO, ID_DEPARTAMENTO) => {

        estadisticas.FAMILIAS_RANKING = [];
        estadisticas.MARCAS_RANKING = [];
        estadisticas.MARCAS_MODELO = [];
        estadisticas.TALLERES_RANKING = [];
        setEstadisticas({ ...estadisticas });

        GetEstadisticasRankingEnAPI(ID_SOCIO, parseInt(MES), ANYO, ID_DEPARTAMENTO).then((licencia) => {
            if (licencia !== undefined && licencia !== null) {
                //  let ANYOS = obtenerAnyosEjercicios(licencia.REGISTROS);
                // actualizarRegistroAnyoGrafico(ANYOS)

                estadisticas.FAMILIAS_RANKING = licencia.FAMILIAS;
                estadisticas.MARCAS_RANKING = licencia.MARCAS;
                estadisticas.MARCAS_MODELO = licencia.MARCA_MODELO;

                estadisticas.CODIGO_MOTOR = licencia.CODIGO_MOTOR;
                estadisticas.TALLERES_RANKING = licencia.TALLERES;
                setEstadisticas({ ...estadisticas });
            } else {
                estadisticas.FAMILIAS_RANKING = null;
                estadisticas.MARCAS_RANKING = null;
                estadisticas.MARCAS_MODELO = null;
                estadisticas.CODIGO_MOTOR = null;
                estadisticas.TALLERES_RANKING = null;

                setEstadisticas({ ...estadisticas });

            }
        })
    }



    const GetEstadisticasNextAssistTecnicoNivel = (ID_SOCIO, MES, ANYO, ID_DEPARTAMENTO) => {


        estadisticas.PRIORIDAD = [];
        estadisticas.PRIORIDAD_DEPARTAMENTO = []

        setEstadisticas({ ...estadisticas });

        GetEstadisticasNextAssistTecnicoNivelEnAPI(ID_SOCIO, parseInt(MES), ANYO, ID_DEPARTAMENTO).then((licencia) => {
            if (licencia !== undefined && licencia !== null) {
                //  let ANYOS = obtenerAnyosEjercicios(licencia.REGISTROS);
                // actualizarRegistroAnyoGrafico(ANYOS)

                estadisticas.PRIORIDAD = licencia.REGISTROS;
                estadisticas.PRIORIDAD_DEPARTAMENTO = licencia.FINALIZADAS_PRIORIDAD_DEPARTAMENTO;
                setEstadisticas({ ...estadisticas });
            } else {

                estadisticas.PRIORIDAD = null;
                estadisticas.PRIORIDAD_DEPARTAMENTO = null

                setEstadisticas({ ...estadisticas });

            }
        })
    }





    const obtenerEstadisticaEjercicioGrafico = (registros, TIPO_DATOS) => {
        let ANYOS = obtenerAnyosEjercicios(registros);
        let grafico = [];

        registros.map((item, i) => {
            let BUSCAR_MES = grafico.find((registro, i) => registro.MES_NO === item.MES_NO)
            if (BUSCAR_MES === undefined) {
                grafico.push({
                    "MES": item.MES,
                    "MES_NO": item.MES_NO,
                })
            }
        });

        grafico.map((registro, i) => {
            let cambio = registros.filter((item, i) => item.MES_NO === registro.MES_NO);

            ANYOS.map((registro_anyo) => {
                let ANYO_FALTANTE = cambio.find((lista) => lista.ANYO === registro);
                if (ANYO_FALTANTE === undefined) {
                    registro[`${registro_anyo}`] = 0;

                }
            })

            cambio.map((lista) => {
                registro[`${lista.ANYO}`] = TIPO_DATOS === "CONSULTAS" ? lista.CONSULTAS : parseInt(lista.TALLERES);

            })
        })


        return grafico;
    }




    const obtenerEstadisticaRanking = (registros) => {
        let ANYOS = obtenerAnyosEjercicios(registros);
        let grafico = [];

        let MES_NO_MARCA = [];
        registros.map((item) => {
            let resultado = MES_NO_MARCA.find((registro, i) => registro === item.TALLERES)
            if (resultado === undefined) {
                MES_NO_MARCA.push(item.TALLERES)
            }
        })


        registros.map((item, i) => {
            item.MES_NO = MES_NO_MARCA.indexOf(item.TALLERES);
        })


        registros.map((item, i) => {
            let BUSCAR_MES = grafico.find((registro, i) => registro.MES_NO === item.MES_NO)

            if (BUSCAR_MES === undefined) {
                grafico.push({
                    "MES": item.TALLERES,
                    "MES_NO": item.MES_NO,
                })
            }
        });

        grafico.map((registro, i) => {
            let cambio = registros.filter((item, i) => item.MES_NO === registro.MES_NO);

            ANYOS.map((registro_anyo) => {
                let ANYO_FALTANTE = cambio.find((lista) => lista.ANYO === registro);
                if (ANYO_FALTANTE === undefined) {
                    registro[`${registro_anyo}`] = 0;

                }
            })

            cambio.map((lista) => {
                registro[`${lista.ANYO}`] = lista.CONSULTAS;

            })
        })

        return grafico;
    }


    const obtenerEstadisticaMarcaTabla = (registros) => {
        let ANYOS = obtenerAnyosEjercicios(registros);
        let grafico = [];

        let MES_NO_MARCA = [];
        registros.map((item) => {
            let resultado = MES_NO_MARCA.find((registro, i) => registro === item.MARCA)
            if (resultado === undefined) {
                MES_NO_MARCA.push(item.MARCA)
            }
        })


        registros.map((item, i) => {
            item.MES_NO = MES_NO_MARCA.indexOf(item.MARCA);
        })


        registros.map((item, i) => {
            let BUSCAR_MES = grafico.find((registro, i) => registro.MES_NO === item.MES_NO)

            if (BUSCAR_MES === undefined) {
                grafico.push({
                    "MES": item.MARCA,
                    "MES_NO": item.MES_NO,
                })
            }
        });

        grafico.map((registro, i) => {
            let cambio = registros.filter((item, i) => item.MES_NO === registro.MES_NO);

            ANYOS.map((registro_anyo) => {
                let ANYO_FALTANTE = cambio.find((lista) => lista.ANYO === registro);
                if (ANYO_FALTANTE === undefined) {
                    registro[`${registro_anyo}`] = 0;

                }
            })

            cambio.map((lista) => {
                registro[`${lista.ANYO}`] = lista.CONSULTAS;

            })
        })

        return grafico;
    }



    const obtenerEstadisticaFamiliaTabla = (registros) => {
        let ANYOS = obtenerAnyosEjercicios(registros);
        let grafico = [];

        let MES_NO_MARCA = [];
        registros.map((item) => {
            let resultado = MES_NO_MARCA.find((registro, i) => registro === item.FAMILIA)
            if (resultado === undefined) {
                MES_NO_MARCA.push(item.FAMILIA)
            }
        })


        registros.map((item, i) => {
            item.MES_NO = MES_NO_MARCA.indexOf(item.FAMILIA);
        })


        registros.map((item, i) => {
            let BUSCAR_MES = grafico.find((registro, i) => registro.MES_NO === item.MES_NO)

            if (BUSCAR_MES === undefined) {
                grafico.push({
                    "MES": item.FAMILIA,
                    "MES_NO": item.MES_NO,
                })
            }
        });

        grafico.map((registro, i) => {
            let cambio = registros.filter((item, i) => item.MES_NO === registro.MES_NO);

            ANYOS.map((registro_anyo) => {
                let ANYO_FALTANTE = cambio.find((lista) => lista.ANYO === registro);
                if (ANYO_FALTANTE === undefined) {
                    registro[`${registro_anyo}`] = 0;

                }
            })

            cambio.map((lista) => {
                registro[`${lista.ANYO}`] = lista.CONSULTAS;

            })
        })

        return grafico;
    }



    const obtenerEstadisticaTipoTareaTabla = (registros) => {
        let ANYOS = obtenerAnyosEjercicios(registros);
        let grafico = [];

        let MES_NO_MARCA = [];
        registros.map((item) => {
            let resultado = MES_NO_MARCA.find((registro, i) => registro === item.TIPO_TAREA)
            if (resultado === undefined) {
                MES_NO_MARCA.push(item.TIPO_TAREA)
            }
        })


        registros.map((item, i) => {
            item.MES_NO = MES_NO_MARCA.indexOf(item.TIPO_TAREA);
        })


        registros.map((item, i) => {
            let BUSCAR_MES = grafico.find((registro, i) => registro.MES_NO === item.MES_NO)

            if (BUSCAR_MES === undefined) {
                grafico.push({
                    "MES": item.TIPO_TAREA,
                    "MES_NO": item.MES_NO,
                })
            }
        });

        grafico.map((registro, i) => {
            let cambio = registros.filter((item, i) => item.MES_NO === registro.MES_NO);

            ANYOS.map((registro_anyo) => {
                let ANYO_FALTANTE = cambio.find((lista) => lista.ANYO === registro);
                if (ANYO_FALTANTE === undefined) {
                    registro[`${registro_anyo}`] = 0;

                }
            })

            cambio.map((lista) => {
                registro[`${lista.ANYO}`] = lista.CONSULTAS;

            })
        })

        return grafico;
    }



    const changeKeyObjects = (arr, replaceKeys) => {
        return arr.map(item => {

            const newItem = {};

            Object.keys(item).forEach(key => {
                let replace = replaceKeys[key] === undefined ? key : replaceKeys[key]
                newItem[replace] = item[[key]];
            });

            return newItem;

        });
    };


    const EstadisticasSertecMensualesPorUsuarioCSV = () => {
        let registros = obtenerEstadisticaEjercicioGrafico(estadisticas.EJERCICIOS, "CONSULTAS");

        const replaceKeys = { MES: traducirPagina("Mes") };
        const REGISTROS_TRADUCIDOS = changeKeyObjects(registros, replaceKeys);


        GetEjerciciosCSVEnAPI(REGISTROS_TRADUCIDOS).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")
                }
            }
        })
    }




    const EstadisticasRankingCSV = (TIPO_RANKING) => {
        let replaceKeys = {};

        let TIPO_REGISTRO = [];
        switch (TIPO_RANKING) {
            case "tab-1_G5":
                TIPO_REGISTRO = estadisticas.TALLERES_RANKING;
                replaceKeys = { TALLERES: traducirPagina("Taller").toUpperCase(), CONSULTAS: traducirPagina("Consultas").toUpperCase() };
                break;
            case "tab-2_G5":
                TIPO_REGISTRO = estadisticas.FAMILIAS_RANKING;
                replaceKeys = { FAMILIA: traducirPagina("Familia").toUpperCase(), CONSULTAS: traducirPagina("Consultas").toUpperCase(), };
                break;
            case "tab-3_G5":
                TIPO_REGISTRO = estadisticas.MARCAS_RANKING;
                replaceKeys = { MARCA: traducirPagina("Marca").toUpperCase(), CONSULTAS: traducirPagina("Consultas").toUpperCase() };
                break;
            case "tab-4_G5":
                TIPO_REGISTRO = estadisticas.MARCAS_MODELO;
                replaceKeys = { MARCA: traducirPagina("Marca").toUpperCase(), MODELOS: traducirPagina("Modelo").toUpperCase(), CONSULTAS: traducirPagina("Consultas").toUpperCase() };
                break;
            case "tab-5_G5":
                TIPO_REGISTRO = estadisticas.CODIGO_MOTOR;
                replaceKeys = { MATRICULA_CODIGO_MOTOR: traducirPagina("Codigo_motor").toUpperCase(), CONSULTAS: traducirPagina("Consultas").toUpperCase() };
                break;
        }


        const REGISTROS_TRADUCIDOS = changeKeyObjects(TIPO_REGISTRO, replaceKeys);



        GetCSVEnAPI(REGISTROS_TRADUCIDOS).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")
                }
            }
        })
    }


    const EstadisticaTecnicoCSV = () => {


        let replaceKeys = {
            NOMBRE: traducirPagina("Nombre").toUpperCase(),
            DIAS_PRODUCTIVOS: traducirPagina("DiasProductivos").toUpperCase(),
            TAREAS_FINALIZADAS: traducirPagina("Cerradas").toUpperCase(),
            TAREAS_AYUDAS: traducirPagina("Ayudas").toUpperCase(),
            TAREAS_INTERVENIDAS: traducirPagina("Total").toUpperCase(),
            TAREAS_DIA: traducirPagina("TareaDia").toUpperCase(),
            MEDIA_RESPUESTA: traducirPagina("Tiempo").toUpperCase(),

        };

        const TIPO_REGISTRO = estadisticas.TECNICOS;
        let LISTA_TECNICO = [];

        TIPO_REGISTRO.map((registro) => {
            let objeto = {
                NOMBRE: registro.NOMBRE,
                DIAS_PRODUCTIVOS: registro.DIAS_PRODUCTIVOS,
                TAREAS_FINALIZADAS: registro.TAREAS_FINALIZADAS,
                TAREAS_AYUDAS: registro.TAREAS_AYUDAS,
                TAREAS_INTERVENIDAS: registro.TAREAS_INTERVENIDAS,
                TAREAS_DIA: registro.TAREAS_DIA,
                MEDIA_RESPUESTA: registro.MEDIA_RESPUESTA,

            }
            LISTA_TECNICO.push(objeto)
        })


        const REGISTROS_TRADUCIDOS = changeKeyObjects(LISTA_TECNICO, replaceKeys);



        GetCSVEnAPI(REGISTROS_TRADUCIDOS).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")
                }
            }
        })
    }


    const TotalesCSV = () => {

        let replaceKeys = {
            NOMBRE_TALLER: traducirPagina("Taller").toUpperCase(),
            MATRICULA_MARCA: traducirPagina("Marca").toUpperCase(),
            MATRICULA_MODELO: traducirPagina("Modelo").toUpperCase(),
            MATRICULA_MOTOR: traducirPagina("Motor").toUpperCase(),
            MATRICULA: traducirPagina("Matricula").toUpperCase(),
            TECNICO_CIERRE: traducirPagina("Tecnico").toUpperCase(),
            TIPO_ABONO_DEVOLUCION: traducirPagina("Tipo").toUpperCase(),
            NIVEL_TAREA: traducirPagina("label_Nivel").toUpperCase(),
            TIPO_TAREA: traducirPagina("Tipo_de_tarea").toUpperCase(),
            GRUPO_MONTAJE: traducirPagina("label_Tipologia").toUpperCase(),
            FECHA: traducirPagina("Fecha").toUpperCase(),
        };

        const TIPO_REGISTRO = estadisticas.TOTALES;
        let LISTA_TECNICO = [];

        TIPO_REGISTRO.map((registro) => {
            let objeto = {
                NOMBRE_TALLER: registro.NOMBRE_TALLER,
                MATRICULA_MARCA: registro.MATRICULA_MARCA,
                MATRICULA_MODELO: registro.MATRICULA_MODELO,
                MATRICULA_MOTOR: registro.MATRICULA_MOTOR,
                MATRICULA: registro.MATRICULA,
                TECNICO_CIERRE: registro.TECNICO_CIERRE,
                TIPO_ABONO_DEVOLUCION: registro.TIPO_ABONO_DEVOLUCION,
                NIVEL_TAREA: registro.NIVEL_TAREA,
                TIPO_TAREA: registro.TIPO_TAREA,
                GRUPO_MONTAJE: registro.GRUPO_MONTAJE,
                FECHA: registro.FECHA,
            }
            LISTA_TECNICO.push(objeto)
        })


        const REGISTROS_TRADUCIDOS = changeKeyObjects(LISTA_TECNICO, replaceKeys);



        GetCSVEnAPI(REGISTROS_TRADUCIDOS).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")
                }
            }
        })
    }



    const EstadisticasSertecMensualTalleresCSV = () => {
        let registros = obtenerEstadisticaEjercicioGrafico(estadisticas.TALLERES_EVOLUCION, "TALLERES");

        const replaceKeys = { MES: traducirPagina("Mes") };
        const REGISTROS_TRADUCIDOS = changeKeyObjects(registros, replaceKeys);

        GetEjerciciosCSVEnAPI(REGISTROS_TRADUCIDOS).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")
                }
            }
        })
    }

    const GetMarcasCSVEnAPICSV = () => {
        let registros = obtenerEstadisticaMarcaTabla(estadisticas.MARCAS);

        registros.map((item, i) => {
            item.MARCA = item.MES
            delete item.MES
        })

        const replaceKeys = { MARCA: traducirPagina("Marca") };
        const REGISTROS_TRADUCIDOS = changeKeyObjects(registros, replaceKeys);

        GetMarcasCSVEnAPI(REGISTROS_TRADUCIDOS).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")
                }
            }
        })
    }

    const GetFamiliaCSV = () => {
        let registros = obtenerEstadisticaFamiliaTabla(estadisticas.FAMILIAS);

        registros.map((item, i) => {
            item.FAMILIA = item.MES
            delete item.MES
        })

        const replaceKeys = { FAMILIA: traducirPagina("Familia") };
        const REGISTROS_TRADUCIDOS = changeKeyObjects(registros, replaceKeys);

        GetFamiliaCSVEnAPI(REGISTROS_TRADUCIDOS).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")
                }
            }
        })
    }


    const GetTiposTareaCSV = () => {
        let registros = obtenerEstadisticaTipoTareaTabla(estadisticas.TIPO_TAREA);

        registros.map((item, i) => {
            item.TIPO_TAREA = item.MES
            delete item.MES
            delete item.MES_NO

        })

        const replaceKeys = { TIPO_TAREA: traducirPagina("Tipo_tarea") };
        const REGISTROS_TRADUCIDOS = changeKeyObjects(registros, replaceKeys);

        GetTiposTareaCSVEnAPI(REGISTROS_TRADUCIDOS).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")
                }
            }
        })
    }


    const ordenarRegistroTabla = (registros) => {
        let NUEVA_LISTA = [];
        NUEVA_LISTA = registros.filter((registro) => registro !== "MES" && registro !== "MES_NO")
        return NUEVA_LISTA;
    }




    const buscarAnios = () => {
        GetEstadisticasAnyosEnAPI().then((registros) => {
            if (registros.ANYOS !== undefined && registros.ANYOS !== null && registros.ANYOS.length > 0) {
                setAnios(registros.ANYOS)

            } else {
                setAnios(null)
            }
        })
    }



    const EstadisticaPrioridadCSV = () => {
        let LISTA_REGISTRO = []

        if (tabPorDefecto == 1) {

            let replaceKeys = {
                USUARIO: traducirPagina("Tecnico").toUpperCase(),
                PRIORIDAD: traducirPagina("Prioridad").toUpperCase(),
                DEPARTAMENTO: traducirPagina("Departamento").toUpperCase(),
                FINALIZADAS: traducirPagina("Finalizadas").toUpperCase(),
            };

            const TIPO_REGISTRO = estadisticas.PRIORIDAD;
            let LISTA_TECNICO = [];

            TIPO_REGISTRO.map((registro) => {
                let objeto = {
                    USUARIO: registro.USUARIO,
                    PRIORIDAD: registro.PRIORIDAD,
                    DEPARTAMENTO: registro.DEPARTAMENTO,
                    FINALIZADAS: registro.FINALIZADAS,


                }
                LISTA_TECNICO.push(objeto)
            })

            const REGISTROS_TRADUCIDOS = changeKeyObjects(LISTA_TECNICO, replaceKeys);




            LISTA_REGISTRO = REGISTROS_TRADUCIDOS

        } else {

            let replaceKeys = {
                PRIORIDAD: traducirPagina("Prioridad").toUpperCase(),
                DEPARTAMENTO: traducirPagina("Departamento").toUpperCase(),
                FINALIZADAS: traducirPagina("Finalizadas").toUpperCase(),
            };

            const TIPO_REGISTRO = estadisticas.PRIORIDAD_DEPARTAMENTO;
            let LISTA_TECNICO = [];

            TIPO_REGISTRO.map((registro) => {
                let objeto = {
                    PRIORIDAD: registro.PRIORIDAD,
                    DEPARTAMENTO: registro.DEPARTAMENTO,
                    FINALIZADAS: registro.FINALIZADAS,


                }
                LISTA_TECNICO.push(objeto)
            })

            const REGISTROS_TRADUCIDOS_PRIORIDAD_DEPARTAMENTO = changeKeyObjects(LISTA_TECNICO, replaceKeys);


            LISTA_REGISTRO = REGISTROS_TRADUCIDOS_PRIORIDAD_DEPARTAMENTO

        }


        GetCSVEnAPI(LISTA_REGISTRO).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")
                }
            }
        })



    }





    const fechaInicial = () => {

        let fechaLocal = obtenerFechaLocalObjeto(false);
        //const FECHA_INICIAL = construirFecha(fechaLocal.MES, fechaLocal.ANIO.toString(), { DESDE: 4, HASTA: 5 })
        filtroFecha.ACCION_DESDE = 4;
        filtroFecha.ACCION_HASTA = 5;
        //filtroFecha.FECHA_PARTIDA = FECHA_INICIAL
        filtroFecha.ANYO_SELECCIONADO = fechaLocal.ANIO
        filtroFecha.MES_SELECCIONADO = traducirPagina(convertirCodigoAMeses(fechaLocal.MES))



        setFiltroFecha({ ...filtroFecha })

        return { DIA: fechaLocal.DIA, MES: parseInt(fechaLocal.MES), ANYO: fechaLocal.ANIO }
    }


    const modelarMarcas = (MARCAS, FILTROS) => {
        const { ID_CABECERA, ORDER_DIR } = FILTROS;

        let LISTA = [];
        if (MARCAS !== undefined && MARCAS !== null && MARCAS.length > 0) {
            obtenerEstadisticaMarcaTabla(MARCAS).map((registro, i) => {
                delete registro.MES_NO;
                LISTA.push(registro);
            })
        }

        if (parseInt(ID_CABECERA) >= 0) {
            switch (ORDER_DIR) {
                case "A":
                    LISTA.sort(dynamicSortAsc(ID_CABECERA === 0 ? "MES" : ID_CABECERA))
                    break;
                case "D":
                    LISTA.sort(dynamicSortDesc(ID_CABECERA === 0 ? "MES" : ID_CABECERA))
                    break;
            }
        }

        return LISTA;
    }



    const GetEstadisticasTecnicoSatisfaccion = (ID_SOCIO, ID_DEPARTAMENTO, DIA, MES, ANYO) => {
        //estadisticas.TOTALES = [];
        //setEstadisticas({ ...estadisticas });
        abortFetch()
        feed_back.REGISTROS_GRADO_SATISFACCION = []
        feed_back.REGISTROS_TAREA = []
        feed_back.REGISTROS_TECNICO_SATISFACCION = []
        setFeed_back({ ...feed_back })

        GetEstadisticasTecnicoSatisfaccionEnAPI(ID_SOCIO, ID_DEPARTAMENTO, DIA, MES, ANYO).then((licencia) => {

            if (licencia !== undefined && licencia !== null && licencia.OK) {

                const { REGISTROS_GRADO_SATISFACCION, REGISTROS_TAREA, REGISTROS_TECNICO_SATISFACCION } = licencia;

                feed_back.REGISTROS_GRADO_SATISFACCION = REGISTROS_GRADO_SATISFACCION.length > 0 ? REGISTROS_GRADO_SATISFACCION : null
                feed_back.REGISTROS_TAREA = REGISTROS_TAREA.length > 0 ? REGISTROS_TAREA : null
                feed_back.REGISTROS_TECNICO_SATISFACCION = REGISTROS_TECNICO_SATISFACCION.length > 0 ? REGISTROS_TECNICO_SATISFACCION : null
                setFeed_back({ ...feed_back })

            }

        })
    }


    const tipoGrado = (ID_GRADO) => {
        let traducir = ""
        switch (ID_GRADO) {
            case "6":
                traducir = traducirPagina("label_inaceptable").toUpperCase()
                break;
            case "5":
                traducir = traducirPagina("label_no_satisfactorio").toUpperCase()

                break;
            case "4":
                traducir = traducirPagina("label_aceptable").toUpperCase()

                break;
            case "3":
                traducir = traducirPagina("label_satisfactorio").toUpperCase()

                break;
            case "2":
                traducir = traducirPagina("label_muy_satisfactorio").toUpperCase()

                break;

        }
        return traducir

    }



    const modelarRegistros = (registros) => {
        let registros_original = [...registros]
        let result = registros.filter((value, index, self) => self.findIndex((m) => m.TECNICO_CIERRE === value.TECNICO_CIERRE) === index);

        result.map((item) => {

            let GRADO_6 = registros_original.find((registro) => registro.ID_MAE_GRADO_SATISFACCION === "6" && registro.TECNICO_CIERRE === item.TECNICO_CIERRE)
            let GRADO_5 = registros_original.find((registro) => registro.ID_MAE_GRADO_SATISFACCION === "5" && registro.TECNICO_CIERRE === item.TECNICO_CIERRE)
            let GRADO_4 = registros_original.find((registro) => registro.ID_MAE_GRADO_SATISFACCION === "4" && registro.TECNICO_CIERRE === item.TECNICO_CIERRE)
            let GRADO_3 = registros_original.find((registro) => registro.ID_MAE_GRADO_SATISFACCION === "3" && registro.TECNICO_CIERRE === item.TECNICO_CIERRE)
            let GRADO_2 = registros_original.find((registro) => registro.ID_MAE_GRADO_SATISFACCION === "2" && registro.TECNICO_CIERRE === item.TECNICO_CIERRE)

            item.GRADO_6 = GRADO_6 !== undefined ? GRADO_6.NUMERO : ""
            item.GRADO_6_CIENTO = GRADO_6 !== undefined ? GRADO_6.CIENTO_FEEDBACK : ""

            item.GRADO_5 = GRADO_5 !== undefined ? GRADO_5.NUMERO : ""
            item.GRADO_5_CIENTO = GRADO_5 !== undefined ? GRADO_5.CIENTO_FEEDBACK : ""

            item.GRADO_4 = GRADO_4 !== undefined ? GRADO_4.NUMERO : ""
            item.GRADO_4_CIENTO = GRADO_4 !== undefined ? GRADO_4.CIENTO_FEEDBACK : ""

            item.GRADO_3 = GRADO_3 !== undefined ? GRADO_3.NUMERO : ""
            item.GRADO_3_CIENTO = GRADO_3 !== undefined ? GRADO_3.CIENTO_FEEDBACK : ""

            item.GRADO_2 = GRADO_2 !== undefined ? GRADO_2.NUMERO : ""
            item.GRADO_2_CIENTO = GRADO_2 !== undefined ? GRADO_2.CIENTO_FEEDBACK : ""

            return item

        })
        return result
    }





    if (!hayRegristros && props.ABRIR_FICHA) {
        setHayRegristros(true);
        let accesoLicencia = obtenerUsuario();
        let { DIA, MES, ANYO } = fechaInicial();

        filtroFecha.MES_SELECCIONADO = CodigoAMeses(MES)
        filtroFecha.NUMERO_MES_SELECCIONADO = parseInt(MES)
        filtroFecha.DIA_SELECCIONADO = DIA

        setFiltroFecha({ ...filtroFecha })


        setSociosLocal(accesoLicencia.SOCIOS)
        buscarAnios();

        if (accesoLicencia.SOCIOS.length === 1) {
            setSocioSeleccionado(accesoLicencia.SOCIOS[0].ID_SOCIO)

            GetEstadisticas(accesoLicencia.SOCIOS[0].ID_SOCIO, MES, ANYO, filtroFecha.ID_DEPARTAMENTO)
        } else {
            GetEstadisticas("", MES, ANYO, "")
        }

        GetNextAssistBODepartamentos(1, "A", "", "");

    } else {
        if (!props.ABRIR_FICHA && hayRegristros) {
            setTAB_SELECCIONADO("tab-1")
            setHayRegristros(false)
        }
    }



    return (
        <div>
            <Drawer
                width={1380}
                onClose={() => {
                    props.CERRAR_FICHA(false)
                }}
                visible={props.ABRIR_FICHA}
                closable={false}
                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ zIndex: '999', color: '#fff' }}>


                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false) }}></CloseOutlined >
                        <div> {props.title}</div>
                    </div>

                    <div className='itemHeaderDrawer2'>

                    </div>
                </div>



                <div className="centerMenu2">
                    <div style={{ fontSize: '16px', fontWeight: '500', display: 'flex', height: '40px', lineHeight: '40px' }}>

                        <div className='estadistica_item1'>

                            {sociosLocal !== null ?
                                <Select
                                    showSearch
                                    allowClear={true}
                                    size={"large"}

                                    value={socioSeleccionado === 0 ? <span style={{ color: '#999' }}>{traducirPagina("Seleccione_socio").toUpperCase()}</span> : socioSeleccionado}

                                    style={{ width: "300px", textAlign: 'left', marginRight: '10px' }}
                                    optionFilterProp="children"
                                    onChange={(e) => {

                                        if (e === undefined || e === null) {
                                            setSocioSeleccionado(0);
                                            if (tipoVista.EVOLUCION) {
                                                GetEstadisticasEvolucion(0, filtroFecha.ID_DEPARTAMENTO)

                                            } else if (tipoVista.TECNICO) {
                                                GetEstadisticasTecnico(0, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)

                                            } else if (tipoVista.RANKING) {
                                                GetEstadisticasRanking(0, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)

                                            } else if (tipoVista.PRIORIDAD) {
                                                GetEstadisticasNextAssistTecnicoNivel(0, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)

                                            } else if (tipoVista.TOTALES) {
                                                GetEstadisticasEvolucionMesDetalle(0, filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO))
                                            } else if (tipoVista.FEEDBACK) {
                                                GetEstadisticasTecnicoSatisfaccion(0, filtroFecha.ID_DEPARTAMENTO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO))

                                            } else {
                                                GetEstadisticas("", convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)
                                            }

                                            //GetEstadisticasEvolucion("")

                                        } else {
                                            setSocioSeleccionado(parseInt(e));
                                            if (tipoVista.EVOLUCION) {
                                                GetEstadisticasEvolucion(parseInt(e), filtroFecha.ID_DEPARTAMENTO)
                                            } else if (tipoVista.TECNICO) {
                                                GetEstadisticasTecnico(parseInt(e), convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)

                                            } else if (tipoVista.RANKING) {
                                                GetEstadisticasRanking(parseInt(e), convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)

                                            } else if (tipoVista.PRIORIDAD) {
                                                GetEstadisticasNextAssistTecnicoNivel(parseInt(e), convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)

                                            } else if (tipoVista.TOTALES) {
                                                GetEstadisticasEvolucionMesDetalle(parseInt(e), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO))
                                            } else if (tipoVista.FEEDBACK) {
                                                GetEstadisticasTecnicoSatisfaccion(parseInt(e), filtroFecha.ID_DEPARTAMENTO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO))

                                            } else {
                                                GetEstadisticas(parseInt(e), convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)
                                            }
                                            //GetEstadisticasEvolucion(parseInt(e))
                                        }

                                    }}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {sociosLocal.length > 0 ?
                                        sociosLocal.map((socio) =>
                                            <Option key={socio.ID_SOCIO} value={socio.ID_SOCIO}>{socio.NOMBRE_SOCIO}</Option>
                                        )
                                        :
                                        null
                                    }
                                </Select>
                                :
                                <div style={{ textAlign: 'center' }}>
                                    <h4>{traducirPagina("Info_error_socio")}</h4>
                                </div>
                            }


                            {departamentos !== null ?
                                <Select
                                    showSearch
                                    allowClear={true}
                                    size={"large"}

                                    value={filtroFecha.ID_DEPARTAMENTO === "" ? <span style={{ color: '#999' }}>{traducirPagina("Seleccione_departamento").toUpperCase()}</span> : filtroFecha.ID_DEPARTAMENTO}

                                    style={{ width: "300px", textAlign: 'left', marginRight: '10px' }}
                                    optionFilterProp="children"
                                    onChange={(e) => {

                                        if (e === undefined || e === null) {
                                            filtroFecha.ID_DEPARTAMENTO = ""
                                            setFiltroFecha({ ...filtroFecha })

                                            if (tipoVista.EVOLUCION) {
                                                GetEstadisticasEvolucion(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO)

                                            } else if (tipoVista.TECNICO) {

                                                GetEstadisticasTecnico(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)

                                            } else if (tipoVista.RANKING) {

                                                GetEstadisticasRanking(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)

                                            } else if (tipoVista.PRIORIDAD) {
                                                GetEstadisticasNextAssistTecnicoNivel(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)

                                            } else if (tipoVista.TOTALES) {
                                                GetEstadisticasEvolucionMesDetalle(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO))

                                            } else if (tipoVista.FEEDBACK) {
                                                GetEstadisticasTecnicoSatisfaccion(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO))

                                            } else {
                                                GetEstadisticas(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)

                                            }

                                        } else {
                                            filtroFecha.ID_DEPARTAMENTO = e
                                            setFiltroFecha({ ...filtroFecha })

                                            if (tipoVista.EVOLUCION) {
                                                GetEstadisticasEvolucion(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO)
                                            } else if (tipoVista.TECNICO) {
                                                GetEstadisticasTecnico(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)

                                            } else if (tipoVista.RANKING) {
                                                GetEstadisticasRanking(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)

                                            } else if (tipoVista.PRIORIDAD) {
                                                GetEstadisticasNextAssistTecnicoNivel(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)

                                            } else if (tipoVista.TOTALES) {
                                                GetEstadisticasEvolucionMesDetalle(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO))

                                            } else if (tipoVista.FEEDBACK) {
                                                GetEstadisticasTecnicoSatisfaccion(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO))

                                            }
                                            else {
                                                GetEstadisticas(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)

                                            }

                                        }


                                    }}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {departamentos.length > 0 ?
                                        departamentos.map((departamento) =>
                                            <Option key={departamento.ID} value={departamento.ID}>{departamento.NOMBRE}</Option>
                                        )
                                        :
                                        null
                                    }
                                </Select>

                                :
                                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                    <h4>{traducirPagina("Sin_resultados")}</h4>
                                </div>
                            }
                        </div>


                        <div className='estadistica_item2'>

                            <button
                                className={`btn_Generico  ${tipoVista.GLOBALES ? 'activarBotonGenerico' : 'desactivarBotonGenerico'}`} onClick={() => {
                                    tipoVista.GLOBALES = true
                                    tipoVista.EVOLUCION = false
                                    tipoVista.TECNICO = false
                                    tipoVista.RANKING = false
                                    tipoVista.PRIORIDAD = false
                                    tipoVista.TOTALES = false
                                    tipoVista.FEEDBACK = false


                                    //filtroFecha.CAMBIO_MES = true
                                    //setFiltroFecha({...filtroFecha})

                                    GetEstadisticas(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)
                                    setTipoVista({ ...tipoVista })

                                }}>  <span style={{ fontSize: '16px' }}>{traducirPagina("Globales").toUpperCase()}</span>
                            </button>

                            <button
                                className={`btn_Generico ${tipoVista.EVOLUCION ? 'activarBotonGenerico' : 'desactivarBotonGenerico'}`} onClick={() => {
                                    tipoVista.GLOBALES = false
                                    tipoVista.EVOLUCION = true
                                    tipoVista.TECNICO = false
                                    tipoVista.RANKING = false
                                    tipoVista.PRIORIDAD = false
                                    tipoVista.TOTALES = false
                                    tipoVista.FEEDBACK = false


                                    setTipoVista({ ...tipoVista })
                                    setTAB_SELECCIONADO("tab-1_G5");

                                    let accesoLicencia = obtenerUsuario();


                                    if (accesoLicencia.SOCIOS.length === 1) {

                                        GetEstadisticasEvolucion(accesoLicencia.SOCIOS[0].ID_SOCIO, filtroFecha.ID_DEPARTAMENTO)
                                    } else {
                                        //Añadiendo parametro socio
                                        GetEstadisticasEvolucion(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO)
                                    }


                                }}>   <span style={{ fontSize: '16px' }}>{traducirPagina("Evolucion").toUpperCase()}</span>
                            </button>
                            {usuario.ID_ROL === 2 || usuario.ID_ROL === 5 ?
                                <button
                                    className={`btn_Generico ${tipoVista.TECNICO ? 'activarBotonGenerico' : 'desactivarBotonGenerico'}`} onClick={() => {
                                        tipoVista.GLOBALES = false
                                        tipoVista.EVOLUCION = false
                                        tipoVista.TECNICO = true
                                        tipoVista.RANKING = false
                                        tipoVista.PRIORIDAD = false
                                        tipoVista.TOTALES = false
                                        tipoVista.FEEDBACK = false

                                        setTipoVista({ ...tipoVista })

                                        let accesoLicencia = obtenerUsuario();
                                        // let { MES, ANYO } = fechaInicial();

                                        if (accesoLicencia.SOCIOS.length === 1) {

                                            GetEstadisticasTecnico(accesoLicencia.SOCIOS[0].ID_SOCIO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)
                                        } else {
                                            //Añadiendo parametro socio
                                            GetEstadisticasTecnico(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)
                                        }



                                    }}>   <span style={{ fontSize: '16px' }}>{traducirPagina("Tecnico").toUpperCase()}</span>
                                </button>

                                :
                                null
                            }


                            <button
                                className={`btn_Generico ${tipoVista.RANKING ? 'activarBotonGenerico' : 'desactivarBotonGenerico'}`} onClick={() => {
                                    tipoVista.GLOBALES = false
                                    tipoVista.EVOLUCION = false
                                    tipoVista.TECNICO = false
                                    tipoVista.RANKING = true
                                    tipoVista.PRIORIDAD = false
                                    tipoVista.TOTALES = false
                                    tipoVista.FEEDBACK = false


                                    setTipoVista({ ...tipoVista })
                                    setTAB_SELECCIONADO("tab-1_G5");

                                    let accesoLicencia = obtenerUsuario();


                                    if (accesoLicencia.SOCIOS.length === 1) {
                                        GetEstadisticasRanking(accesoLicencia.SOCIOS[0].ID_SOCIO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)
                                    } else {
                                        GetEstadisticasRanking(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)
                                    }

                                }}>   <span style={{ fontSize: '16px' }}>{"RANKING"}</span>
                            </button>



                            <button
                                className={`btn_Generico ${tipoVista.PRIORIDAD ? 'activarBotonGenerico' : 'desactivarBotonGenerico'}`} onClick={() => {
                                    tipoVista.GLOBALES = false
                                    tipoVista.EVOLUCION = false
                                    tipoVista.TECNICO = false
                                    tipoVista.RANKING = false
                                    tipoVista.PRIORIDAD = true
                                    tipoVista.TOTALES = false
                                    tipoVista.FEEDBACK = false


                                    setTipoVista({ ...tipoVista })

                                    let accesoLicencia = obtenerUsuario();

                                    //let { MES, ANYO } = fechaInicial();
                                    /*
                                    filtroFecha.MES_SELECCIONADO = CodigoAMeses(MES) 
                                    setFiltroFecha({...filtroFecha})
                                    */


                                    if (accesoLicencia.SOCIOS.length === 1) {
                                        GetEstadisticasNextAssistTecnicoNivel(accesoLicencia.SOCIOS[0].ID_SOCIO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)
                                    } else {
                                        GetEstadisticasNextAssistTecnicoNivel(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)
                                    }

                                }}>   <span style={{ fontSize: '16px' }}>{traducirPagina("Prioridad").toUpperCase()}</span>
                            </button>

                            <button
                                className={`btn_Generico ${tipoVista.TOTALES ? 'activarBotonGenerico' : 'desactivarBotonGenerico'}`} onClick={() => {
                                    tipoVista.GLOBALES = false
                                    tipoVista.EVOLUCION = false
                                    tipoVista.TECNICO = false
                                    tipoVista.RANKING = false
                                    tipoVista.PRIORIDAD = false
                                    tipoVista.TOTALES = true
                                    tipoVista.FEEDBACK = false

                                    setTipoVista({ ...tipoVista })

                                    let accesoLicencia = obtenerUsuario();

                                    let { DIA, MES, ANYO } = fechaInicial();

                                    filtroFecha.MES_SELECCIONADO = CodigoAMeses(MES)
                                    filtroFecha.NUMERO_MES_SELECCIONADO = parseInt(MES)
                                    filtroFecha.DIA_SELECCIONADO = DIA
                                    filtroFecha.CAMBIO_DIA = true

                                    setFiltroFecha({ ...filtroFecha })

                                    if (accesoLicencia.SOCIOS.length === 1) {

                                        //GetEstadisticasTecnico(accesoLicencia.SOCIOS[0].ID_SOCIO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)

                                        GetEstadisticasEvolucionMesDetalle(accesoLicencia.SOCIOS[0].ID_SOCIO, filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO))

                                    } else {
                                        //Añadiendo parametro socio
                                        //GetEstadisticasTecnico(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)

                                        GetEstadisticasEvolucionMesDetalle(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO))
                                    }



                                }}>   <span style={{ fontSize: '16px' }}>{traducirPagina("label_Totales").toUpperCase()}</span>
                            </button>


                            <button
                                className={`btn_Generico ${tipoVista.FEEDBACK ? 'activarBotonGenerico' : 'desactivarBotonGenerico'}`} onClick={() => {
                                    tipoVista.GLOBALES = false
                                    tipoVista.EVOLUCION = false
                                    tipoVista.TECNICO = false
                                    tipoVista.RANKING = false
                                    tipoVista.PRIORIDAD = false
                                    tipoVista.TOTALES = false
                                    tipoVista.FEEDBACK = true

                                    setTipoVista({ ...tipoVista })

                                    let accesoLicencia = obtenerUsuario();

                                    let { DIA, MES, ANYO } = fechaInicial();

                                    filtroFecha.MES_SELECCIONADO = CodigoAMeses(MES)
                                    filtroFecha.NUMERO_MES_SELECCIONADO = parseInt(MES)
                                    filtroFecha.DIA_SELECCIONADO = DIA
                                    filtroFecha.CAMBIO_DIA = true

                                    setFiltroFecha({ ...filtroFecha })

                                    if (accesoLicencia.SOCIOS.length === 1) {


                                        GetEstadisticasTecnicoSatisfaccion(accesoLicencia.SOCIOS[0].ID_SOCIO, filtroFecha.ID_DEPARTAMENTO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO))

                                    } else {
                                        //Añadiendo parametro socio

                                        GetEstadisticasTecnicoSatisfaccion(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO))
                                    }



                                }}>   <span style={{ fontSize: '16px' }}>{traducirPagina("label_feedback").toUpperCase()}</span>
                            </button>




                        </div>
                    </div>
                </div>




                <div className="Container_estadistica_assist">
                    {tipoVista.GLOBALES ?

                        <>
                            <div className='container_filtro_assist'>
                                <div>

                                </div>

                                <div>
                                    <MDBDropdown>
                                        <MDBDropdownToggle nav>
                                            <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_MES ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', marginRight: '10px', color: '#fff' }}>
                                                {traducirPagina(filtroFecha.MES_SELECCIONADO).toUpperCase()}
                                            </div>
                                        </MDBDropdownToggle>

                                        <MDBDropdownMenu right >
                                            {mesesDelAnio.map((mes, i) =>
                                                <MDBDropdownItem style={{ padding: '10px' }} key={i} onClick={(e) => {
                                                    let MES_LOCAL = CodigoAMeses((i + 1))

                                                    //const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(MES_LOCAL), filtroFecha.ANYO_SELECCIONADO, { DESDE: 0, HASTA: 1 });


                                                    filtroFecha.CAMBIO_DIA = false;
                                                    filtroFecha.CAMBIO_MES = true;
                                                    filtroFecha.CAMBIO_ANIO = true;
                                                    filtroFecha.ACCION_DESDE = 0;
                                                    filtroFecha.ACCION_HASTA = 1;
                                                    //filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA
                                                    filtroFecha.MES_SELECCIONADO = MES_LOCAL



                                                    setFiltroFecha({ ...filtroFecha })


                                                    GetEstadisticas(socioSeleccionado, convertirAMesACodigo(MES_LOCAL), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)


                                                }}>  {traducirPagina(mes).toUpperCase()}</MDBDropdownItem>
                                            )}
                                        </MDBDropdownMenu>
                                    </MDBDropdown>




                                    <MDBDropdown>
                                        <MDBDropdownToggle nav>
                                            <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_ANIO ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff' }}>
                                                {filtroFecha.ANYO_SELECCIONADO}
                                            </div>
                                        </MDBDropdownToggle>

                                        <MDBDropdownMenu right >
                                            {anios !== null ?
                                                anios.map((anio, i) =>
                                                    <MDBDropdownItem key={i} onClick={(e) => {
                                                        //const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), e.target.innerText, { DESDE: 0, HASTA: 1 });


                                                        filtroFecha.CAMBIO_DIA = false;
                                                        filtroFecha.CAMBIO_MES = true;
                                                        filtroFecha.CAMBIO_ANIO = true;
                                                        filtroFecha.ACCION_DESDE = 0;
                                                        filtroFecha.ACCION_HASTA = 1;
                                                        //filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA;
                                                        filtroFecha.ANYO_SELECCIONADO = e.target.innerText;

                                                        setFiltroFecha({ ...filtroFecha })

                                                        GetEstadisticas(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(e.target.innerText), filtroFecha.ID_DEPARTAMENTO)

                                                        //licenciasSertec(3, "D", false, filtroSeleccionado.TAREAS_CERRADAS, obtenerLicenciaLocal().ID_TALLER, null, FECHA_PARTIDA, 2, 3);

                                                    }}>  {anio}</MDBDropdownItem>
                                                )
                                                :
                                                null
                                            }
                                        </MDBDropdownMenu>
                                    </MDBDropdown>
                                </div>



                            </div>


                            <Col span={24} style={{ fontSize: '18px', fontWeight: '500', color: '#000', textAlign: 'center', justifyContent: 'center', alignItems: 'center', padding: '0px 10px' }}>
                                <Col span={8}>
                                    <div style={{ height: '200px', backgroundColor: '#a5df17', padding: '20px', margin: '10px' }}>
                                        <h4 style={{ lineHeight: '50px', fontSize: '24px', fontWeight: 'bold', color: '#fff', margin: '0px' }}>{traducirPagina("Talleres_activos").toUpperCase()}</h4>

                                        <div className='container_talleres_activos'>
                                            <div className='item_talleres_activos'>
                                                {estadisticas !== null && estadisticas.CONSULTAS !== null && estadisticas.CONSULTAS.length > 0 ? convertirImporte(estadisticas.CONSULTAS[0].TOTAL_TALLERES, "") : ""}

                                                {
                                                    estadisticas !== null && estadisticas.CONSULTAS !== null && estadisticas.CONSULTAS.length > 0 ?
                                                        estadisticas.CONSULTAS[0].TOTAL_TALLERES > estadisticas.CONSULTAS[0].TOTAL_TALLERES_MES_ANTERIOR ?
                                                            <ArrowUpOutlined></ArrowUpOutlined>
                                                            :
                                                            <ArrowDownOutlined></ArrowDownOutlined>

                                                        :
                                                        null
                                                }

                                                <div className='item_talleres_mes'>{estadisticas !== null && estadisticas.CONSULTAS !== null && estadisticas.CONSULTAS.length > 0 ? convertirImporte(estadisticas.CONSULTAS[0].NOMBRE_MES_ANTERIOR) : ""}    <div>{estadisticas !== null && estadisticas.CONSULTAS !== null && estadisticas.CONSULTAS.length > 0 ? estadisticas.CONSULTAS[0].TOTAL_TALLERES_MES_ANTERIOR : ""}</div>  </div>
                                            </div>
                                        </div>


                                        <div className='container_estadistica_activos'>
                                            <div className='container_estadistica_activos_item'>
                                                {estadisticas !== null && estadisticas.CONSULTAS !== null && estadisticas.CONSULTAS.length > 0 ? `${traducirPagina("Altas")}: ${convertirImporte(estadisticas.CONSULTAS[0].TOTAL_ALTAS_MES, "")}` : ""}
                                            </div>
                                            <div className='container_estadistica_activos_item'>
                                                {estadisticas !== null && estadisticas.CONSULTAS !== null && estadisticas.CONSULTAS.length > 0 ? `${traducirPagina("Bajas")}: ${convertirImporte(estadisticas.CONSULTAS[0].TOTAL_BAJAS_MES, "")}` : ""}
                                            </div>

                                        </div>

                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div style={{ height: '200px', backgroundColor: '#1890ff', padding: '20px', margin: '10px' }}>
                                        <h4 style={{ lineHeight: '50px', fontSize: '24px', fontWeight: 'bold', color: '#fff', margin: '0px' }}>{traducirPagina("Origen_tareas")}</h4>


                                        <div className='containerServiciosAssist'>
                                            <div className='containerServiciosAssist_item'>
                                                <div className='containerServiciosAssist_item_icono'>
                                                    <CustomerServiceOutlined></CustomerServiceOutlined>
                                                </div>
                                                <div className='containerServiciosAssist_item_importe'>
                                                    {estadisticas !== null && estadisticas.CONSULTAS !== null && estadisticas.CONSULTAS.length > 0 ? `${convertirImporte(estadisticas.CONSULTAS[0].TOTAL_LLAMADAS_MES, "")}` : ""}
                                                </div>
                                            </div>

                                            <div className='containerServiciosAssist_item'>
                                                <div className='containerServiciosAssist_item_icono'>
                                                    <MobileOutlined ></MobileOutlined>
                                                </div>
                                                <div className='containerServiciosAssist_item_importe'>
                                                    {estadisticas !== null && estadisticas.CONSULTAS !== null && estadisticas.CONSULTAS.length > 0 ? `${convertirImporte(estadisticas.CONSULTAS[0].TOTAL_APP_MES, "")}` : ""}
                                                </div>
                                            </div>

                                            <div className='containerServiciosAssist_item'>
                                                <div className='containerServiciosAssist_item_icono'>
                                                    <DesktopOutlined></DesktopOutlined>
                                                </div>
                                                <div className='containerServiciosAssist_item_importe'>
                                                    {estadisticas !== null && estadisticas.CONSULTAS !== null && estadisticas.CONSULTAS.length > 0 ? `${convertirImporte(estadisticas.CONSULTAS[0].TOTAL_WEB_MES, "")}` : ""}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div style={{ height: '200px', backgroundColor: '#dcdcdc', padding: '20px', margin: '10px' }}>
                                        <h4 style={{ lineHeight: '50px', fontSize: '24px', fontWeight: 'bold', margin: '0px' }}>{traducirPagina("Total_tareas").toUpperCase()} </h4>
                                        <h5 style={{ lineHeight: '40px', fontSize: '26px', fontWeight: 'bold' }}>{estadisticas !== null && estadisticas.CONSULTAS !== null && estadisticas.CONSULTAS.length > 0 ? `${convertirImporte(estadisticas.CONSULTAS[0].TOTAL_MES, "")}` : ""} </h5>


                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td style={{ fontSize: '18px', fontWeight: '600', textAlign: 'left', color: '#000' }}>{`${traducirPagina("Consultas")}:`}</td>
                                                    <td style={{ fontSize: '18px', fontWeight: '600', textAlign: 'right', color: '#000', width: '150px' }}>{estadisticas !== null && estadisticas.CONSULTAS !== null && estadisticas.CONSULTAS.length > 0 ? `${convertirImporte(estadisticas.CONSULTAS[0].TOTAL_CONSULTAS_MES, "")}` : ""}</td>

                                                </tr>
                                                <tr>
                                                    <td style={{ fontSize: '18px', fontWeight: '600', textAlign: 'left', color: '#000' }}>{`${traducirPagina("Documentacion")}:`}</td>
                                                    <td style={{ fontSize: '18px', fontWeight: '600', textAlign: 'right', color: '#000', width: '150px' }}>{estadisticas !== null && estadisticas.CONSULTAS !== null && estadisticas.CONSULTAS.length > 0 ? `${convertirImporte(estadisticas.CONSULTAS[0].TOTAL_DOCUMENTACION_MES, "")}` : ""}</td>
                                                </tr>

                                            </tbody>
                                        </table>


                                    </div>
                                </Col>


                                <Col span={24}>
                                    <div style={{ padding: '10px', margin: '10px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <h3 style={{ lineHeight: '50px', fontSize: '24px', textAlign: 'left' }}>{traducirPagina("Top_consultas_talleres").toUpperCase()}</h3>

                                            <button style={{ height: '40px', width: '120px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: '#dcdcdc' }} onClick={(e) => {

                                                setRegistroSeleccionado({ ID_SOCIO: socioSeleccionado, SOCIO: "" })
                                                setAbrirFichaEstadistica(true)


                                            }}><EyeOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Mas_info")} </span>  </button>
                                        </div>

                                        {estadisticas.TALLERES === null ?
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                            :
                                            estadisticas.TALLERES.length > 0 ?
                                                <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                    <thead>
                                                        <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                            <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Taller").toUpperCase()}</th>
                                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("Telefono").toUpperCase()} </th>
                                                            <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{"WEB"}</th>
                                                            <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{"APP"}</th>
                                                            <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{traducirPagina("Total").toUpperCase()}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {estadisticas.TALLERES.map((registro, i) =>
                                                            <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.NOMBRE_TALLER}</td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{convertirImporte(registro.CONSULTAS_TELEFONO, "")}</td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{convertirImporte(registro.CONSULTAS_WEB, "")}</td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{convertirImporte(registro.CONSULTAS_APP, "")}</td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{convertirImporte(registro.CONSULTAS_TOTAL, "")}</td>

                                                            </tr>
                                                        )
                                                        }
                                                    </tbody>
                                                </table>
                                                :
                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                        }
                                    </div>
                                </Col>

                                <Col span={24}>
                                    <div style={{ padding: '10px', margin: '10px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <h3 style={{ lineHeight: '50px', fontSize: '24px', textAlign: 'left' }}>{traducirPagina("Volumen_horas").toUpperCase()}</h3>

                                        </div>

                                        {estadisticas.VOLUMEN_HORAS === null ?
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                            :
                                            estadisticas.VOLUMEN_HORAS.length > 0 ?
                                                <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                    <thead>
                                                        <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                            <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Hora").toUpperCase()}</th>
                                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("Hoy").toUpperCase()} </th>
                                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{"%"}</th>
                                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{traducirPagina("Mes").toUpperCase()}</th>
                                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{"%"}</th>
                                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{traducirPagina("Anio").toUpperCase()}</th>
                                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{"%"}</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {estadisticas.VOLUMEN_HORAS.map((registro, i) =>
                                                            <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.HORA}</td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.TAREAS_HOY}</td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.CIENTO_HOY}</td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.TAREAS_MES}</td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.CIENTO_MES}</td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.TAREAS_ANYO}</td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.CIENTO_ANYO}</td>


                                                            </tr>
                                                        )
                                                        }
                                                    </tbody>
                                                </table>
                                                :
                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                        }
                                    </div>
                                </Col>
                            </Col>
                        </>
                        :

                        tipoVista.EVOLUCION ?
                            <Col span={24} style={{ fontSize: '18px', fontWeight: '500', color: '#000', padding: '0px 10px', textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>

                                <div className="tabs_5 effect-5" style={{ color: '#000', marginBottom: '0px' }}>
                                    <input type="radio" id="tab-1_G5" name="tab-effect-5" checked={TAB_SELECCIONADO === "tab-1_G5" ? "checked" : ""} />
                                    <span onClick={(e) => {
                                        setTAB_SELECCIONADO("tab-1_G5");
                                        let ANYOS = obtenerAnyosEjercicios(estadisticas.TALLERES_EVOLUCION);
                                        actualizarRegistroAnyoGrafico(ANYOS)
                                    }}>{traducirPagina("Talleres").toUpperCase()}</span>

                                    <input type="radio" id="tab-2_G5" name="tab-effect-5" checked={TAB_SELECCIONADO === "tab-2_G5" ? "checked" : ""} />
                                    <span onClick={(e) => {
                                        setTAB_SELECCIONADO("tab-2_G5");

                                        let ANYOS = obtenerAnyosEjercicios(estadisticas.EJERCICIOS);
                                        actualizarRegistroAnyoGrafico(ANYOS)

                                    }}>{traducirPagina("Consultas").toUpperCase()}</span>

                                    <input type="radio" id="tab-3_G5" name="tab-effect-5" checked={TAB_SELECCIONADO === "tab-3_G5" ? "checked" : ""} />
                                    <span onClick={(e) => { setTAB_SELECCIONADO("tab-3_G5"); }}>{traducirPagina("Marcas").toUpperCase()}</span>

                                    <input type="radio" id="tab-4_G5" name="tab-effect-5" checked={TAB_SELECCIONADO === "tab-4_G5" ? "checked" : ""} />
                                    <span onClick={(e) => { setTAB_SELECCIONADO("tab-4_G5"); }}>{traducirPagina("Familias").toUpperCase()}</span>

                                    <input type="radio" id="tab-5_G5" name="tab-effect-5" checked={TAB_SELECCIONADO === "tab-5_G5" ? "checked" : ""} />
                                    <span onClick={(e) => { setTAB_SELECCIONADO("tab-5_G5"); }}>{traducirPagina("Tipo_tarea").toUpperCase()}</span>


                                    <div className="line ease"></div>

                                    <div className="tab-content_G5">

                                        <section id="tab-item-1_G5">


                                            <div style={{ fontSize: '20px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start', marginBottom: '20px', color: '#000' }}>

                                                <div style={{ textAlign: 'left' }}>   <button style={{ height: '40px', width: '120px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: tipoGrafico === "TABLA" ? '#dcdcdc' : '#efefef' }} onClick={(e) => { setTipoGrafico("TABLA") }}><TableOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Tabla")} </span>  </button> </div>

                                                <div style={{ textAlign: 'left', width: '65%' }}>     <button style={{ marginLeft: '20px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: tipoGrafico === "GRAFICO" ? '#dcdcdc' : '#efefef' }} onClick={(e) => { setTipoGrafico("GRAFICO") }}><BarChartOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Grafico")} </span>  </button></div>

                                                <div style={{ textAlign: 'right', display: tipoGrafico === "GRAFICO" ? 'none' : '' }}>
                                                    <button style={{ width: '200px', marginLeft: '20px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: '#4285f4', color: '#fff' }} onClick={(e) => { EstadisticasSertecMensualTalleresCSV() }}><FileExcelOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Descargar_csv")} </span>  </button>
                                                </div>

                                            </div>



                                            {
                                                tipoGrafico === "TABLA" ?
                                                    estadisticas.TALLERES_EVOLUCION === null ?
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                        :
                                                        estadisticas.TALLERES_EVOLUCION.length > 0 ?
                                                            <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                                <thead>
                                                                    <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Mes")}</th>
                                                                        {obtenerAnyosEjercicios(estadisticas.TALLERES_EVOLUCION).sort((a, b) => { return a - b }).map((registro) =>
                                                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} >{registro}</th>
                                                                        )
                                                                        }
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        obtenerEstadisticaEjercicioGrafico(estadisticas.TALLERES_EVOLUCION, "TALLERES").map((registro, i) =>
                                                                            <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MES}</td>
                                                                                {ordenarRegistroTabla(Object.keys(registro)).map((item, i) =>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro[item]}</td>

                                                                                )}
                                                                            </tr>
                                                                        )
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            :
                                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                                    :



                                                    estadisticas.TALLERES_EVOLUCION === null ?
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>

                                                        :

                                                        estadisticas.TALLERES_EVOLUCION.length > 0 ?
                                                            <>
                                                                <LineChart
                                                                    width={1000}
                                                                    height={500}
                                                                    data={obtenerEstadisticaEjercicioGrafico(estadisticas.TALLERES_EVOLUCION, "TALLERES")}
                                                                    margin={{
                                                                        top: 5,
                                                                        right: 30,
                                                                        left: 20,
                                                                        bottom: 5
                                                                    }}
                                                                >
                                                                    <CartesianGrid strokeDasharray="3 3" />
                                                                    <XAxis dataKey="MES" />
                                                                    <YAxis />
                                                                    <Tooltip />
                                                                    <Legend />


                                                                    {registroKeyGrafico.map((registro) =>
                                                                        registroKeyGrafico.filter((item) => item.NOMBRE === registro.NOMBRE && item.ACTIVO).length > 0 ? <Line type="monotone" dataKey={registro.NOMBRE} stroke={registro.COLOR} /> : null
                                                                    )}

                                                                </LineChart>


                                                                {tipoGrafico === "GRAFICO" ?
                                                                    <div style={{ fontSize: '20px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start', marginBottom: '20px', color: '#000' }}>

                                                                        {registroKeyGrafico !== undefined || registroKeyGrafico !== null ?
                                                                            registroKeyGrafico.map((registro) =>
                                                                                <Checkbox checked={registro.ACTIVO}
                                                                                    onChange={(e) => {
                                                                                        registroKeyGrafico.map((item) => {
                                                                                            if (item.NOMBRE === registro.NOMBRE) {
                                                                                                item.ACTIVO = e.target.checked
                                                                                            }
                                                                                        }
                                                                                        )
                                                                                        setRegistroKeyGrafico([...registroKeyGrafico]);
                                                                                    }} ><span style={{ fontSize: '12px', fontWeight: '500', color: '#000' }}>{registro.NOMBRE}</span> </Checkbox>
                                                                            )
                                                                            :
                                                                            null
                                                                        }
                                                                    </div>
                                                                    :
                                                                    null
                                                                }
                                                            </>
                                                            :
                                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '60vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                                            }

                                        </section>

                                        <section id="tab-item-2_G5">


                                            <div style={{ fontSize: '20px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start', marginBottom: '20px', color: '#000' }}>

                                                <div style={{ textAlign: 'left' }}>   <button style={{ height: '40px', width: '120px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: tipoGrafico === "TABLA" ? '#dcdcdc' : '#efefef' }} onClick={(e) => { setTipoGrafico("TABLA") }}><TableOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Tabla")} </span>  </button> </div>

                                                <div style={{ textAlign: 'left', width: '65%' }}>     <button style={{ marginLeft: '20px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: tipoGrafico === "GRAFICO" ? '#dcdcdc' : '#efefef' }} onClick={(e) => { setTipoGrafico("GRAFICO") }}><BarChartOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Grafico")} </span>  </button></div>

                                                <div style={{ textAlign: 'right', display: tipoGrafico === "GRAFICO" ? 'none' : '' }}>
                                                    <button style={{ width: '200px', marginLeft: '20px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: '#4285f4', color: '#fff' }} onClick={(e) => { EstadisticasSertecMensualesPorUsuarioCSV() }}><FileExcelOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Descargar_csv")} </span>  </button>
                                                </div>

                                            </div>



                                            {tipoGrafico === "TABLA" ?
                                                estadisticas.EJERCICIOS === null ?
                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                    :
                                                    estadisticas.EJERCICIOS.length > 0 ?
                                                        <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                            <thead>
                                                                <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                                    <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Mes")}</th>
                                                                    {obtenerAnyosEjercicios(estadisticas.EJERCICIOS).sort((a, b) => { return a - b }).map((registro) =>
                                                                        <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} >{registro}</th>
                                                                    )
                                                                    }
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    obtenerEstadisticaEjercicioGrafico(estadisticas.EJERCICIOS, "CONSULTAS").map((registro, i) =>
                                                                        <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MES}</td>
                                                                            {ordenarRegistroTabla(Object.keys(registro)).map((item, i) =>
                                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro[item]}</td>

                                                                            )}
                                                                        </tr>
                                                                    )
                                                                }
                                                            </tbody>
                                                        </table>
                                                        :
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                                :



                                                estadisticas.EJERCICIOS === null ?


                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                    :
                                                    estadisticas.EJERCICIOS.length > 0 ?
                                                        <>
                                                            <LineChart
                                                                width={1000}
                                                                height={500}
                                                                data={obtenerEstadisticaEjercicioGrafico(estadisticas.EJERCICIOS, "CONSULTAS")}
                                                                margin={{
                                                                    top: 5,
                                                                    right: 30,
                                                                    left: 20,
                                                                    bottom: 5
                                                                }}
                                                            >
                                                                <CartesianGrid strokeDasharray="3 3" />
                                                                <XAxis dataKey="MES" />
                                                                <YAxis />
                                                                <Tooltip />
                                                                <Legend />


                                                                {registroKeyGrafico.map((registro) =>
                                                                    registroKeyGrafico.filter((item) => item.NOMBRE === registro.NOMBRE && item.ACTIVO).length > 0 ? <Line type="monotone" dataKey={registro.NOMBRE} stroke={registro.COLOR} /> : null
                                                                )}

                                                            </LineChart>


                                                            {tipoGrafico === "GRAFICO" ?
                                                                <div style={{ fontSize: '20px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start', marginBottom: '20px', color: '#000' }}>

                                                                    {registroKeyGrafico !== undefined || registroKeyGrafico !== null ?
                                                                        registroKeyGrafico.map((registro) =>
                                                                            <Checkbox checked={registro.ACTIVO}
                                                                                onChange={(e) => {
                                                                                    registroKeyGrafico.map((item) => {
                                                                                        if (item.NOMBRE === registro.NOMBRE) {
                                                                                            item.ACTIVO = e.target.checked
                                                                                        }
                                                                                    }
                                                                                    )
                                                                                    setRegistroKeyGrafico([...registroKeyGrafico]);
                                                                                }} ><span style={{ fontSize: '12px', fontWeight: '500', color: '#000' }}>{registro.NOMBRE}</span> </Checkbox>
                                                                        )
                                                                        :
                                                                        null
                                                                    }
                                                                </div>
                                                                :
                                                                null
                                                            }
                                                        </>
                                                        :
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '60vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                                            }


                                        </section>

                                        <section id="tab-item-3_G5">

                                            {

                                                estadisticas.MARCAS === null ?
                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                    :
                                                    estadisticas.MARCAS.length > 0 ?
                                                        <>
                                                            <div style={{ display: 'flex', justifyContent: 'end', marginBottom: '20px' }}>
                                                                <button style={{ width: '200px', marginLeft: '20px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: '#4285f4', color: '#fff' }} onClick={(e) => { GetMarcasCSVEnAPICSV() }}><FileExcelOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Descargar_csv")} </span>  </button>
                                                            </div>

                                                            <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                                <thead>
                                                                    <tr style={{ backgroundColor: '#e0e0e0' }}>

                                                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}
                                                                            className="formatear_cabecera_icono"
                                                                            onClick={(e) => {
                                                                                const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                                                                filtroMarca.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                                                                filtroMarca.ID_CABECERA = 0
                                                                                filtroMarca.ORDER_DIR = filtroMarca.ACTIVO ? "A" : "D"
                                                                                setFiltroMarca({ ...filtroMarca })
                                                                            }}
                                                                        > {traducirPagina("Marca")} {(filtroMarca.ID_CABECERA === 0 && filtroMarca.ACTIVO) ? <ArrowUpOutlined className={filtroMarca.ID_CABECERA === 0 && filtroMarca.ACTIVO ? "quitar_opacity_icono" : "poner_opacity_icono"}></ArrowUpOutlined> : <ArrowDownOutlined className={filtroMarca.ID_CABECERA === 0 && !filtroMarca.ACTIVO ? "quitar_opacity_icono" : "poner_opacity_icono"}></ArrowDownOutlined>} </th>


                                                                        {obtenerAnyosEjercicios(estadisticas.MARCAS).sort((a, b) => { return a - b }).map((registro) =>
                                                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}
                                                                                className="formatear_cabecera_icono"
                                                                                onClick={(e) => {
                                                                                    const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                                                                    filtroMarca.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                                                                    filtroMarca.ID_CABECERA = registro
                                                                                    filtroMarca.ORDER_DIR = filtroMarca.ACTIVO ? "A" : "D"
                                                                                    setFiltroMarca({ ...filtroMarca })

                                                                                }}> {registro} {(filtroMarca.ID_CABECERA === registro && filtroMarca.ACTIVO) ? <ArrowUpOutlined className={filtroMarca.ID_CABECERA === registro && filtroMarca.ACTIVO ? "quitar_opacity_icono" : "poner_opacity_icono"}></ArrowUpOutlined> : <ArrowDownOutlined className={filtroMarca.ID_CABECERA === registro && !filtroMarca.ACTIVO ? "quitar_opacity_icono" : "poner_opacity_icono"}></ArrowDownOutlined>}  </th>
                                                                        )}


                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        modelarMarcas(estadisticas.MARCAS, filtroMarca).map((registro, i) =>
                                                                            <tr key={i} style={{ backgroundColor: '#fff' }}>

                                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} >{registro.MES}</td>

                                                                                {ordenarRegistroTabla(Object.keys(registro)).map((item, i) =>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} className={"efectoHoverMarca"} onClick={() => { setRegistroMarcaDetalle({ ID_SOCIO: socioSeleccionado, ID_DEPARTAMENTO: filtroFecha.ID_DEPARTAMENTO, MARCA: registro.MES, ANYO: item }); setMarcaDetalle(true) }}>{registro[item]}</td>

                                                                                )}
                                                                            </tr>
                                                                        )
                                                                    }
                                                                </tbody>
                                                            </table>

                                                        </>

                                                        :
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                                            }





                                        </section>

                                        <section id="tab-item-4_G5">
                                            {
                                                estadisticas.FAMILIAS === null ?
                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                    :
                                                    estadisticas.FAMILIAS.length > 0 ?
                                                        <>
                                                            <div style={{ display: 'flex', justifyContent: 'end', marginBottom: '20px' }}>
                                                                <button style={{ width: '200px', marginLeft: '20px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: '#4285f4', color: '#fff' }} onClick={(e) => { GetFamiliaCSV() }}><FileExcelOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Descargar_csv")} </span>  </button>
                                                            </div>

                                                            <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                                <thead>
                                                                    <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Familia")}</th>

                                                                        {obtenerAnyosEjercicios(estadisticas.FAMILIAS).sort((a, b) => { return a - b }).map((registro) =>
                                                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} >{registro}</th>
                                                                        )
                                                                        }
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        obtenerEstadisticaFamiliaTabla(estadisticas.FAMILIAS).map((registro, i) =>
                                                                            <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MES}</td>
                                                                                {ordenarRegistroTabla(Object.keys(registro)).map((item, i) =>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro[item]}</td>

                                                                                )}
                                                                            </tr>
                                                                        )
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </>
                                                        :
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                                            }
                                        </section>

                                        <section id="tab-item-5_G5">
                                            {
                                                estadisticas.TIPO_TAREA === null ?
                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                    :
                                                    estadisticas.TIPO_TAREA.length > 0 ?
                                                        <>
                                                            <div style={{ display: 'flex', justifyContent: 'end', marginBottom: '20px' }}>
                                                                <button style={{ width: '200px', marginLeft: '20px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: '#4285f4', color: '#fff' }} onClick={(e) => { GetTiposTareaCSV() }}><FileExcelOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Descargar_csv")} </span>  </button>
                                                            </div>

                                                            <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                                <thead>

                                                                    <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Tipo_tarea")}</th>

                                                                        {obtenerAnyosEjercicios(estadisticas.TIPO_TAREA).sort((a, b) => { return a - b }).map((registro) =>
                                                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} >{registro}</th>
                                                                        )
                                                                        }

                                                                    </tr>

                                                                </thead>
                                                                <tbody>
                                                                    {

                                                                        obtenerEstadisticaTipoTareaTabla(estadisticas.TIPO_TAREA).map((registro, i) =>
                                                                            <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MES}</td>

                                                                                {ordenarRegistroTabla(Object.keys(registro)).map((item, i) =>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro[item]}</td>

                                                                                )}
                                                                            </tr>
                                                                        )

                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </>
                                                        :
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                                            }
                                        </section>

                                    </div>
                                </div>
                            </Col>
                            :
                            tipoVista.TECNICO ?

                                <>

                                    <div className='container_filtro_assist'>
                                        <div>
                                            <button style={{ width: '200px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: '#4285f4', color: '#fff' }} onClick={(e) => { EstadisticaTecnicoCSV() }}><FileExcelOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Descargar_csv")} </span>  </button>

                                        </div>
                                        <div>

                                            <MDBDropdown>
                                                <MDBDropdownToggle nav>
                                                    <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_DIA ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff', marginRight: '10px', }}>
                                                        {filtroFecha.DIA_SELECCIONADO === 0 ? traducirPagina("Todos").toUpperCase() : filtroFecha.DIA_SELECCIONADO}
                                                    </div>
                                                </MDBDropdownToggle>

                                                <MDBDropdownMenu right style={{ height: '250px', overflow: 'auto' }}>
                                                    {obtenerDiasMes(filtroFecha.NUMERO_MES_SELECCIONADO, filtroFecha.ANYO_SELECCIONADO).map((dia, i) =>
                                                        <MDBDropdownItem key={i} onClick={(e) => {
                                                            filtroFecha.CAMBIO_DIA = true;
                                                            filtroFecha.CAMBIO_MES = true;
                                                            filtroFecha.CAMBIO_ANIO = true;
                                                            filtroFecha.ACCION_DESDE = 0;
                                                            filtroFecha.ACCION_HASTA = 1;

                                                            filtroFecha.DIA_SELECCIONADO = dia;

                                                            setFiltroFecha({ ...filtroFecha })

                                                            GetEstadisticasTecnico(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), filtroFecha.ANYO_SELECCIONADO, filtroFecha.ID_DEPARTAMENTO, dia)


                                                        }}>  {dia === 0 ? traducirPagina("Todos").toUpperCase() : dia}</MDBDropdownItem>
                                                    )
                                                    }

                                                </MDBDropdownMenu>
                                            </MDBDropdown>


                                            <MDBDropdown>
                                                <MDBDropdownToggle nav>
                                                    <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_MES ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', marginRight: '10px', color: '#fff' }}>
                                                        {/*filtroFecha.MES_SELECCIONADO.toUpperCase()*/}
                                                        {traducirPagina(filtroFecha.MES_SELECCIONADO).toUpperCase()}

                                                    </div>
                                                </MDBDropdownToggle>

                                                <MDBDropdownMenu right >
                                                    {mesesDelAnio.map((mes, i) =>
                                                        <MDBDropdownItem style={{ padding: '10px' }} key={i} onClick={(e) => {

                                                            let MES_LOCAL = CodigoAMeses((i + 1))

                                                            //const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(MES_LOCAL), filtroFecha.ANYO_SELECCIONADO, { DESDE: 0, HASTA: 1 });


                                                            filtroFecha.CAMBIO_DIA = true;
                                                            filtroFecha.CAMBIO_MES = true;
                                                            filtroFecha.CAMBIO_ANIO = true;
                                                            filtroFecha.ACCION_DESDE = 0;
                                                            filtroFecha.ACCION_HASTA = 1;
                                                            //filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA
                                                            filtroFecha.MES_SELECCIONADO = MES_LOCAL
                                                            filtroFecha.DIA_SELECCIONADO = 0;

                                                            filtroFecha.NUMERO_MES_SELECCIONADO = i + 1
                                                            setFiltroFecha({ ...filtroFecha })


                                                            GetEstadisticasTecnico(socioSeleccionado, convertirAMesACodigo(MES_LOCAL), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)



                                                        }}>  {traducirPagina(mes).toUpperCase()}</MDBDropdownItem>
                                                    )}
                                                </MDBDropdownMenu>
                                            </MDBDropdown>



                                            <MDBDropdown>
                                                <MDBDropdownToggle nav>
                                                    <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_ANIO ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff' }}>
                                                        {filtroFecha.ANYO_SELECCIONADO}
                                                    </div>
                                                </MDBDropdownToggle>

                                                <MDBDropdownMenu right >
                                                    {anios !== null ?
                                                        anios.map((anio, i) =>
                                                            <MDBDropdownItem key={i} onClick={(e) => {
                                                                //const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), e.target.innerText, { DESDE: 0, HASTA: 1 });


                                                                filtroFecha.CAMBIO_DIA = true;
                                                                filtroFecha.CAMBIO_MES = true;
                                                                filtroFecha.CAMBIO_ANIO = true;
                                                                filtroFecha.ACCION_DESDE = 0;
                                                                filtroFecha.ACCION_HASTA = 1;
                                                                //filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA;
                                                                filtroFecha.ANYO_SELECCIONADO = e.target.innerText;

                                                                setFiltroFecha({ ...filtroFecha })

                                                                GetEstadisticasTecnico(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(e.target.innerText), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)

                                                                //licenciasSertec(3, "D", false, filtroSeleccionado.TAREAS_CERRADAS, obtenerLicenciaLocal().ID_TALLER, null, FECHA_PARTIDA, 2, 3);

                                                            }}>  {anio}</MDBDropdownItem>
                                                        )
                                                        :
                                                        null
                                                    }
                                                </MDBDropdownMenu>
                                            </MDBDropdown>
                                        </div>
                                    </div>

                                    <div className='container_tabla_tecnico'>

                                        {estadisticas === null || estadisticas.TECNICOS === null ?
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                            :
                                            estadisticas.TECNICOS.length > 0 ?
                                                <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                    <thead>
                                                        <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                            <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Nombre").toUpperCase()}</th>

                                                            <th style={{ width: '160px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("DiasProductivos").toUpperCase()} </th>
                                                            <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("Cerradas").toUpperCase()} </th>
                                                            <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("Ayudas").toUpperCase()} </th>
                                                            <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("Total").toUpperCase()} </th>


                                                            <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("TareaDia").toUpperCase()} </th>
                                                            <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("Tiempo").toUpperCase()} </th>
                                                            <th style={{ width: '45px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{ } </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {estadisticas.TECNICOS.map((registro, i) =>
                                                            <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.NOMBRE}</td>


                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.DIAS_PRODUCTIVOS} </td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.TAREAS_FINALIZADAS} </td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.TAREAS_AYUDAS} </td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.TAREAS_INTERVENIDAS} </td>


                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.TAREAS_DIA} </td>
                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.MEDIA_RESPUESTA}</td>

                                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>
                                                                    <div className="flex-container-Grow-Simple">
                                                                        <div style={{ margin: '0px 2px' }} >
                                                                            <button title={"Más ìnformación"} onClick={() => {
                                                                                setAbrirDetalleTareaTecnico(true)
                                                                                setRegistroDetalleTareaTecnico(registro)
                                                                            }}
                                                                                className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                                                <EyeOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                        }
                                                    </tbody>
                                                </table>
                                                :
                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                        }



                                    </div>
                                </>
                                :
                                tipoVista.PRIORIDAD ?

                                    <>

                                        <div className='container_filtro_assist'>

                                            <div>
                                                <button style={{ width: '200px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: '#4285f4', color: '#fff' }} onClick={(e) => { EstadisticaPrioridadCSV() }}><FileExcelOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Descargar_csv")} </span>  </button>
                                            </div>

                                            <div>

                                                <MDBDropdown>
                                                    <MDBDropdownToggle nav>
                                                        <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_MES ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', marginRight: '10px', color: '#fff' }}>
                                                            {/*filtroFecha.MES_SELECCIONADO.toUpperCase()*/}
                                                            {traducirPagina(filtroFecha.MES_SELECCIONADO).toUpperCase()}

                                                        </div>
                                                    </MDBDropdownToggle>

                                                    <MDBDropdownMenu right >
                                                        {mesesDelAnio.map((mes, i) =>
                                                            <MDBDropdownItem style={{ padding: '10px' }} key={i} onClick={(e) => {

                                                                let MES_LOCAL = CodigoAMeses((i + 1))

                                                                //const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(MES_LOCAL), filtroFecha.ANYO_SELECCIONADO, { DESDE: 0, HASTA: 1 });


                                                                filtroFecha.CAMBIO_DIA = true;
                                                                filtroFecha.CAMBIO_MES = true;
                                                                filtroFecha.CAMBIO_ANIO = true;
                                                                filtroFecha.ACCION_DESDE = 0;
                                                                filtroFecha.ACCION_HASTA = 1;
                                                                //filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA
                                                                filtroFecha.MES_SELECCIONADO = MES_LOCAL
                                                                filtroFecha.DIA_SELECCIONADO = 0;

                                                                filtroFecha.NUMERO_MES_SELECCIONADO = i + 1
                                                                setFiltroFecha({ ...filtroFecha })


                                                                GetEstadisticasNextAssistTecnicoNivel(socioSeleccionado, convertirAMesACodigo(MES_LOCAL), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)



                                                            }}>  {traducirPagina(mes).toUpperCase()}</MDBDropdownItem>
                                                        )}
                                                    </MDBDropdownMenu>
                                                </MDBDropdown>



                                                <MDBDropdown>
                                                    <MDBDropdownToggle nav>
                                                        <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_ANIO ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff' }}>
                                                            {filtroFecha.ANYO_SELECCIONADO}
                                                        </div>
                                                    </MDBDropdownToggle>

                                                    <MDBDropdownMenu right >
                                                        {anios !== null ?
                                                            anios.map((anio, i) =>
                                                                <MDBDropdownItem key={i} onClick={(e) => {
                                                                    //const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), e.target.innerText, { DESDE: 0, HASTA: 1 });


                                                                    filtroFecha.CAMBIO_DIA = true;
                                                                    filtroFecha.CAMBIO_MES = true;
                                                                    filtroFecha.CAMBIO_ANIO = true;
                                                                    filtroFecha.ACCION_DESDE = 0;
                                                                    filtroFecha.ACCION_HASTA = 1;
                                                                    //filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA;
                                                                    filtroFecha.ANYO_SELECCIONADO = e.target.innerText;

                                                                    setFiltroFecha({ ...filtroFecha })

                                                                    GetEstadisticasNextAssistTecnicoNivel(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(e.target.innerText), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)

                                                                    //licenciasSertec(3, "D", false, filtroSeleccionado.TAREAS_CERRADAS, obtenerLicenciaLocal().ID_TALLER, null, FECHA_PARTIDA, 2, 3);

                                                                }}>  {anio}</MDBDropdownItem>
                                                            )
                                                            :
                                                            null
                                                        }
                                                    </MDBDropdownMenu>
                                                </MDBDropdown>
                                            </div>
                                        </div>


                                        <Tabs defaultActiveKey={"1"} activeKey={tabPorDefecto} onChange={(tab) => setTabPorDefecto(tab)} >
                                            <TabPane tab={traducirPagina("Msg_tareas_prioridad_tecnico").toUpperCase()} key="1" >

                                                <div className='container_tabla_tecnico'>

                                                    {estadisticas === null || estadisticas.PRIORIDAD === null ?
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                        :
                                                        estadisticas.PRIORIDAD.length > 0 ?
                                                            <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                                <thead>
                                                                    <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Tecnico").toUpperCase()}</th>
                                                                        <th style={{ width: '200px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Prioridad").toUpperCase()} </th>

                                                                        <th style={{ width: '200px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Departamento").toUpperCase()} </th>
                                                                        <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("Finalizadas").toUpperCase()} </th>

                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {estadisticas.PRIORIDAD.map((registro, i) =>
                                                                        <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.USUARIO}</td>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.PRIORIDAD} </td>

                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.DEPARTAMENTO} </td>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.FINALIZADAS} </td>



                                                                        </tr>
                                                                    )
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            :
                                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                                    }

                                                </div>

                                            </TabPane>
                                            <TabPane tab={traducirPagina("Msg_tareas_prioridad").toUpperCase()} key="2" >

                                                <div className='container_tabla_tecnico'>

                                                    {estadisticas === null || estadisticas.PRIORIDAD_DEPARTAMENTO === null ?
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                        :
                                                        estadisticas.PRIORIDAD_DEPARTAMENTO.length > 0 ?
                                                            <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                                <thead>
                                                                    <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                                        <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Prioridad").toUpperCase()} </th>

                                                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Departamento").toUpperCase()} </th>
                                                                        <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("Finalizadas").toUpperCase()} </th>
                                                                        <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{`% ${traducirPagina("Total").toUpperCase()}`} </th>


                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {estadisticas.PRIORIDAD_DEPARTAMENTO.map((registro, i) =>
                                                                        <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.PRIORIDAD} </td>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.DEPARTAMENTO} </td>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.FINALIZADAS} </td>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.CIENTO_TOTAL} </td>



                                                                        </tr>
                                                                    )
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            :
                                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                                    }

                                                </div>

                                            </TabPane>
                                        </Tabs>


                                    </>
                                    :
                                    tipoVista.TOTALES ?
                                        <>
                                            <div className='container_filtro_assist'>
                                                <div>
                                                    <button style={{ width: '200px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: '#4285f4', color: '#fff' }} onClick={(e) => { TotalesCSV() }}><FileExcelOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Descargar_csv")} </span>  </button>

                                                </div>
                                                <div>

                                                    <MDBDropdown>
                                                        <MDBDropdownToggle nav>
                                                            <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_DIA ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff', marginRight: '10px' }}>
                                                                {filtroFecha.DIA_SELECCIONADO === 0 ? traducirPagina("Todos").toUpperCase() : filtroFecha.DIA_SELECCIONADO}
                                                            </div>
                                                        </MDBDropdownToggle>

                                                        <MDBDropdownMenu right style={{ height: '250px', overflow: 'auto' }}>
                                                            {obtenerDiasMes(filtroFecha.NUMERO_MES_SELECCIONADO, filtroFecha.ANYO_SELECCIONADO).map((dia, i) =>
                                                                <MDBDropdownItem key={i} onClick={(e) => {
                                                                    filtroFecha.CAMBIO_DIA = true;
                                                                    filtroFecha.CAMBIO_MES = true;
                                                                    filtroFecha.CAMBIO_ANIO = true;
                                                                    filtroFecha.ACCION_DESDE = 0;
                                                                    filtroFecha.ACCION_HASTA = 1;

                                                                    filtroFecha.DIA_SELECCIONADO = dia;

                                                                    setFiltroFecha({ ...filtroFecha })

                                                                    //GetEstadisticasTecnico(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), filtroFecha.ANYO_SELECCIONADO, filtroFecha.ID_DEPARTAMENTO, dia)

                                                                    GetEstadisticasEvolucionMesDetalle(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO, dia, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(filtroFecha.ANYO_SELECCIONADO))



                                                                }}>  {dia === 0 ? traducirPagina("Todos").toUpperCase() : dia}</MDBDropdownItem>
                                                            )
                                                            }

                                                        </MDBDropdownMenu>
                                                    </MDBDropdown>


                                                    <MDBDropdown>
                                                        <MDBDropdownToggle nav>
                                                            <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_MES ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', marginRight: '10px', color: '#fff' }}>
                                                                {/*filtroFecha.MES_SELECCIONADO.toUpperCase()*/}
                                                                {traducirPagina(filtroFecha.MES_SELECCIONADO).toUpperCase()}

                                                            </div>
                                                        </MDBDropdownToggle>

                                                        <MDBDropdownMenu right >
                                                            {mesesDelAnio.map((mes, i) =>
                                                                <MDBDropdownItem style={{ padding: '10px' }} key={i} onClick={(e) => {

                                                                    let MES_LOCAL = CodigoAMeses((i + 1))

                                                                    //const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(MES_LOCAL), filtroFecha.ANYO_SELECCIONADO, { DESDE: 0, HASTA: 1 });


                                                                    filtroFecha.CAMBIO_DIA = true;
                                                                    filtroFecha.CAMBIO_MES = true;
                                                                    filtroFecha.CAMBIO_ANIO = true;
                                                                    filtroFecha.ACCION_DESDE = 0;
                                                                    filtroFecha.ACCION_HASTA = 1;
                                                                    //filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA
                                                                    filtroFecha.MES_SELECCIONADO = MES_LOCAL
                                                                    filtroFecha.DIA_SELECCIONADO = 0;

                                                                    filtroFecha.NUMERO_MES_SELECCIONADO = i + 1
                                                                    setFiltroFecha({ ...filtroFecha })


                                                                    //GetEstadisticasTecnico(socioSeleccionado, convertirAMesACodigo(MES_LOCAL), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)

                                                                    GetEstadisticasEvolucionMesDetalle(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO, convertirAMesACodigo(MES_LOCAL), parseInt(filtroFecha.ANYO_SELECCIONADO))


                                                                }}>  {traducirPagina(mes).toUpperCase()}</MDBDropdownItem>
                                                            )}
                                                        </MDBDropdownMenu>
                                                    </MDBDropdown>



                                                    <MDBDropdown>
                                                        <MDBDropdownToggle nav>
                                                            <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_ANIO ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff' }}>
                                                                {filtroFecha.ANYO_SELECCIONADO}
                                                            </div>
                                                        </MDBDropdownToggle>

                                                        <MDBDropdownMenu right >
                                                            {anios !== null ?
                                                                anios.map((anio, i) =>
                                                                    <MDBDropdownItem key={i} onClick={(e) => {
                                                                        //const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), e.target.innerText, { DESDE: 0, HASTA: 1 });


                                                                        filtroFecha.CAMBIO_DIA = true;
                                                                        filtroFecha.CAMBIO_MES = true;
                                                                        filtroFecha.CAMBIO_ANIO = true;
                                                                        filtroFecha.ACCION_DESDE = 0;
                                                                        filtroFecha.ACCION_HASTA = 1;
                                                                        //filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA;
                                                                        filtroFecha.ANYO_SELECCIONADO = e.target.innerText;

                                                                        setFiltroFecha({ ...filtroFecha })

                                                                        //licenciasSertec(3, "D", false, filtroSeleccionado.TAREAS_CERRADAS, obtenerLicenciaLocal().ID_TALLER, null, FECHA_PARTIDA, 2, 3);

                                                                        GetEstadisticasEvolucionMesDetalle(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(e.target.innerText))


                                                                    }}>  {anio}</MDBDropdownItem>
                                                                )
                                                                :
                                                                null
                                                            }
                                                        </MDBDropdownMenu>
                                                    </MDBDropdown>
                                                </div>
                                            </div>


                                            <div className='container_tabla_tecnico '>
                                                <div className='altura_totales_estadisticas' style={{ height: 'calc(100vh - 210px)', overflow: 'auto' }}>
                                                    {estadisticas === null || estadisticas.TOTALES === null ?
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                        :
                                                        estadisticas.TOTALES.length > 0 ?
                                                            <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                                <thead>
                                                                    <tr style={{ backgroundColor: '#e0e0e0' }}>

                                                                        <th style={{ minWidth: '250px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Taller").toUpperCase()} </th>
                                                                        <th style={{ minWidth: '130px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Marca").toUpperCase()} </th>
                                                                        <th style={{ minWidth: '220px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Modelo").toUpperCase()} </th>
                                                                        <th style={{ minWidth: '180px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Motor").toUpperCase()} </th>
                                                                        <th style={{ minWidth: '90px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Matriculas").toUpperCase()} </th>

                                                                        <th style={{ minWidth: '200px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Tecnico").toUpperCase()} </th>
                                                                        <th style={{ minWidth: '45px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => { }}>{traducirPagina("Tipo").toUpperCase()} </th>
                                                                        <th style={{ minWidth: '95px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("label_Nivel").toUpperCase()} </th>
                                                                        <th style={{ minWidth: '260px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Tipo_tarea").toUpperCase()} </th>
                                                                        <th style={{ minWidth: '173px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("label_Tipologia").toUpperCase()} </th>
                                                                        <th style={{ minWidth: '85px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} onClick={(e) => { }}>{traducirPagina("Fecha").toUpperCase()} </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {estadisticas.TOTALES.map((registro, i) =>
                                                                        <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.NOMBRE_TALLER}</td>


                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MATRICULA_MARCA} </td>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MATRICULA_MODELO} </td>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MATRICULA_MOTOR} </td>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MATRICULA} </td>


                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.TECNICO_CIERRE} </td>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro.TIPO_ABONO_DEVOLUCION}</td>

                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.NIVEL_TAREA} </td>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.TIPO_TAREA}</td>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.GRUPO_MONTAJE}</td>
                                                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.FECHA}</td>

                                                                        </tr>
                                                                    )
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            :
                                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                                    }

                                                </div>
                                            </div>
                                        </>
                                        :

                                        tipoVista.FEEDBACK ?
                                            <>

                                                <div className='container_filtro_assist'>

                                                    <div>
                                                    </div>

                                                    <div>

                                                        <MDBDropdown>
                                                            <MDBDropdownToggle nav>
                                                                <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_MES ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', marginRight: '10px', color: '#fff' }}>
                                                                    {/*filtroFecha.MES_SELECCIONADO.toUpperCase()*/}
                                                                    {traducirPagina(filtroFecha.MES_SELECCIONADO).toUpperCase()}

                                                                </div>
                                                            </MDBDropdownToggle>

                                                            <MDBDropdownMenu right >
                                                                {mesesDelAnio.map((mes, i) =>
                                                                    <MDBDropdownItem style={{ padding: '10px' }} key={i} onClick={(e) => {

                                                                        let MES_LOCAL = CodigoAMeses((i + 1))

                                                                        filtroFecha.CAMBIO_DIA = true;
                                                                        filtroFecha.CAMBIO_MES = true;
                                                                        filtroFecha.CAMBIO_ANIO = true;
                                                                        filtroFecha.ACCION_DESDE = 0;
                                                                        filtroFecha.ACCION_HASTA = 1;
                                                                        //filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA
                                                                        filtroFecha.MES_SELECCIONADO = MES_LOCAL
                                                                        filtroFecha.DIA_SELECCIONADO = 0;

                                                                        filtroFecha.NUMERO_MES_SELECCIONADO = i + 1
                                                                        setFiltroFecha({ ...filtroFecha })



                                                                        //GetEstadisticasNextAssistTecnicoNivel(socioSeleccionado, convertirAMesACodigo(MES_LOCAL), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)

                                                                        GetEstadisticasTecnicoSatisfaccion(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO, convertirAMesACodigo(MES_LOCAL), parseInt(filtroFecha.ANYO_SELECCIONADO))


                                                                    }}>  {traducirPagina(mes).toUpperCase()}</MDBDropdownItem>
                                                                )}
                                                            </MDBDropdownMenu>
                                                        </MDBDropdown>



                                                        <MDBDropdown>
                                                            <MDBDropdownToggle nav>
                                                                <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_ANIO ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff' }}>
                                                                    {filtroFecha.ANYO_SELECCIONADO}
                                                                </div>
                                                            </MDBDropdownToggle>

                                                            <MDBDropdownMenu right >
                                                                {anios !== null ?
                                                                    anios.map((anio, i) =>
                                                                        <MDBDropdownItem key={i} onClick={(e) => {
                                                                            //const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), e.target.innerText, { DESDE: 0, HASTA: 1 });


                                                                            filtroFecha.CAMBIO_DIA = true;
                                                                            filtroFecha.CAMBIO_MES = true;
                                                                            filtroFecha.CAMBIO_ANIO = true;
                                                                            filtroFecha.ACCION_DESDE = 0;
                                                                            filtroFecha.ACCION_HASTA = 1;
                                                                            //filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA;
                                                                            filtroFecha.ANYO_SELECCIONADO = e.target.innerText;

                                                                            setFiltroFecha({ ...filtroFecha })

                                                                            //GetEstadisticasNextAssistTecnicoNivel(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(e.target.innerText), filtroFecha.ID_DEPARTAMENTO, filtroFecha.DIA_SELECCIONADO)
                                                                            GetEstadisticasTecnicoSatisfaccion(socioSeleccionado, filtroFecha.ID_DEPARTAMENTO, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(e.target.innerText))


                                                                        }}>  {anio}</MDBDropdownItem>
                                                                    )
                                                                    :
                                                                    null
                                                                }
                                                            </MDBDropdownMenu>
                                                        </MDBDropdown>
                                                    </div>
                                                </div>


                                                <div className='container_feed_back' >

                                                    <div className='grupo_feed_back'>

                                                        {feed_back.REGISTROS_TAREA !== null && feed_back.REGISTROS_TAREA.length > 0 ?
                                                            <div className='feed_back_item1'>
                                                                <h1>FEEDBACKS</h1>

                                                                <span>{`${feed_back.REGISTROS_TAREA[0].CIENTO_FEEDBACK} %`}</span>

                                                                <div>{`${traducirPagina("label_total_tareas_mes")} : `}  <span>{feed_back.REGISTROS_TAREA[0].NUMERO_TAREAS_TOTAL}</span></div>
                                                                <div>{`${traducirPagina("label_total_tareas_feed")} : `} <span>{feed_back.REGISTROS_TAREA[0].NUMERO_TAREAS_FEEDBACK_TOTAL}</span></div>
                                                            </div>
                                                            : null
                                                        }

                                                        {feed_back.REGISTROS_GRADO_SATISFACCION !== null && feed_back.REGISTROS_GRADO_SATISFACCION.length > 0 ?


                                                            <div className='feed_back_item2'>

                                                                <div className='feed_back_grados'>
                                                                    {feed_back.REGISTROS_GRADO_SATISFACCION.sort(dynamicSortAsc("ID_MAE_GRADO_SATISFACCION")).map((item) =>
                                                                        <div>
                                                                            <img src={`./imagenes/grados/${item.ID_MAE_GRADO_SATISFACCION}.png`}></img>
                                                                            <div>{tipoGrado(item.ID_MAE_GRADO_SATISFACCION)}</div>
                                                                            <div className='txt_numero_feedback'>{`(${item.NUMERO} feedbacks)`}</div>
                                                                            <div>{`${item.CIENTO_FEEDNACK} %`}</div>

                                                                        </div>
                                                                    )}



                                                                </div>

                                                            </div>
                                                            : null
                                                        }


                                                    </div>


                                                    <div style={{ marginTop: '20px' }}>

                                                        {feed_back.REGISTROS_TECNICO_SATISFACCION === null ?
                                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                            :

                                                            feed_back.REGISTROS_TECNICO_SATISFACCION.length > 0 ?
                                                                <>
                                                                    <h4 style={{ lineHeight: '50px', fontSize: '24px', fontWeight: 'bold', margin: '0px' }}>{traducirPagina("label_feedback_Tecnico").toUpperCase()} </h4>


                                                                    <table style={{ width: '100%' }}>
                                                                        <thead>
                                                                            <tr style={{ backgroundColor: '#e0e0e0', color: '#000' }}>
                                                                                <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Tecnico").toUpperCase()}</th>
                                                                                <th style={{ width: '180px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{traducirPagina("label_muy_satisfactorio").toUpperCase()}</th>
                                                                                <th style={{ width: '180px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{traducirPagina("label_satisfactorio").toUpperCase()}</th>
                                                                                <th style={{ width: '180px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{traducirPagina("label_aceptable").toUpperCase()}</th>
                                                                                <th style={{ width: '180px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{traducirPagina("label_no_satisfactorio").toUpperCase()}</th>
                                                                                <th style={{ width: '180px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{traducirPagina("label_inaceptable").toUpperCase()}</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {modelarRegistros(feed_back.REGISTROS_TECNICO_SATISFACCION).map((registro, i) =>
                                                                                <tr key={i} style={{ backgroundColor: '#fff', color: '#000' }}>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.TECNICO_CIERRE}</td>

                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}><div> {`${registro.GRADO_2} ${registro.GRADO_2_CIENTO !== "" ? `/ ${registro.GRADO_2_CIENTO} %` : ""}`}</div></td>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}><div> {`${registro.GRADO_3} ${registro.GRADO_3_CIENTO !== "" ? `/ ${registro.GRADO_3_CIENTO} %` : ""}`} </div></td>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}><div> {`${registro.GRADO_4} ${registro.GRADO_4_CIENTO !== "" ? `/ ${registro.GRADO_4_CIENTO} %` : ""}`} </div> </td>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}><div>  {`${registro.GRADO_5} ${registro.GRADO_5_CIENTO !== "" ? `/ ${registro.GRADO_5_CIENTO} %` : ""}`}</div> </td>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}><div>{`${registro.GRADO_6} ${registro.GRADO_6_CIENTO !== "" ? `/ ${registro.GRADO_6_CIENTO} %` : ""}`}</div> </td>
                                                                                </tr>
                                                                            )
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </>
                                                                :
                                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                                                        }
                                                    </div>
                                                </div>
                                            </>

                                            :
                                            <>

                                                <div className='container_filtro_assist'>
                                                    <div>
                                                        <button style={{ width: '200px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: '#4285f4', color: '#fff' }} onClick={(e) => { EstadisticasRankingCSV(TAB_SELECCIONADO) }}><FileExcelOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Descargar_csv")} </span>  </button>

                                                    </div>

                                                    <div>
                                                        <MDBDropdown>
                                                            <MDBDropdownToggle nav>
                                                                <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_MES ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', marginRight: '10px', color: '#fff' }}>
                                                                    {/*filtroFecha.MES_SELECCIONADO.toUpperCase()*/}
                                                                    {traducirPagina(filtroFecha.MES_SELECCIONADO).toUpperCase()}

                                                                </div>
                                                            </MDBDropdownToggle>

                                                            <MDBDropdownMenu right >
                                                                {mesesDelAnio.map((mes, i) =>
                                                                    <MDBDropdownItem style={{ padding: '10px' }} key={i} onClick={(e) => {
                                                                        let MES_LOCAL = CodigoAMeses((i + 1))

                                                                        //const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(MES_LOCAL), filtroFecha.ANYO_SELECCIONADO, { DESDE: 0, HASTA: 1 });


                                                                        filtroFecha.CAMBIO_DIA = false;
                                                                        filtroFecha.CAMBIO_MES = true;
                                                                        filtroFecha.CAMBIO_ANIO = true;
                                                                        filtroFecha.ACCION_DESDE = 0;
                                                                        filtroFecha.ACCION_HASTA = 1;
                                                                        //filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA
                                                                        filtroFecha.MES_SELECCIONADO = MES_LOCAL
                                                                        setFiltroFecha({ ...filtroFecha })


                                                                        GetEstadisticasRanking(socioSeleccionado, convertirAMesACodigo(MES_LOCAL), parseInt(filtroFecha.ANYO_SELECCIONADO), filtroFecha.ID_DEPARTAMENTO)

                                                                    }}>  {traducirPagina(mes).toUpperCase()}</MDBDropdownItem>
                                                                )}
                                                            </MDBDropdownMenu>
                                                        </MDBDropdown>



                                                        <MDBDropdown>
                                                            <MDBDropdownToggle nav>
                                                                <div style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_ANIO ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff' }}>
                                                                    {filtroFecha.ANYO_SELECCIONADO}
                                                                </div>
                                                            </MDBDropdownToggle>

                                                            <MDBDropdownMenu right >
                                                                {anios !== null ?
                                                                    anios.map((anio, i) =>
                                                                        <MDBDropdownItem key={i} onClick={(e) => {
                                                                            //const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), e.target.innerText, { DESDE: 0, HASTA: 1 });


                                                                            filtroFecha.CAMBIO_DIA = false;
                                                                            filtroFecha.CAMBIO_MES = true;
                                                                            filtroFecha.CAMBIO_ANIO = true;
                                                                            filtroFecha.ACCION_DESDE = 0;
                                                                            filtroFecha.ACCION_HASTA = 1;
                                                                            //filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA;
                                                                            filtroFecha.ANYO_SELECCIONADO = e.target.innerText;
                                                                            setFiltroFecha({ ...filtroFecha })

                                                                            GetEstadisticasRanking(socioSeleccionado, convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), parseInt(e.target.innerText), filtroFecha.ID_DEPARTAMENTO)

                                                                            //licenciasSertec(3, "D", false, filtroSeleccionado.TAREAS_CERRADAS, obtenerLicenciaLocal().ID_TALLER, null, FECHA_PARTIDA, 2, 3);

                                                                        }}>  {anio}</MDBDropdownItem>
                                                                    )
                                                                    :
                                                                    null
                                                                }
                                                            </MDBDropdownMenu>
                                                        </MDBDropdown>

                                                    </div>
                                                </div>


                                                <div className="tabs_4 effect-4" style={{ color: '#000', marginBottom: '0px' }}>

                                                    <input type="radio" id="tab-1_G5" name="tab-effect-3" checked={TAB_SELECCIONADO === "tab-1_G5" ? "checked" : ""} />
                                                    <span onClick={(e) => { setTAB_SELECCIONADO("tab-1_G5"); }}>{traducirPagina("Talleres").toUpperCase()}</span>


                                                    <input type="radio" id="tab-2_G5" name="tab-effect-3" checked={TAB_SELECCIONADO === "tab-2_G5" ? "checked" : ""} />
                                                    <span onClick={(e) => { setTAB_SELECCIONADO("tab-2_G5"); }}>{traducirPagina("Familias").toUpperCase()}</span>

                                                    <input type="radio" id="tab-3_G5" name="tab-effect-3" checked={TAB_SELECCIONADO === "tab-3_G5" ? "checked" : ""} />
                                                    <span onClick={(e) => { setTAB_SELECCIONADO("tab-3_G5"); }}>{traducirPagina("Marcas").toUpperCase()}</span>

                                                    <input type="radio" id="tab-4_G5" name="tab-effect-3" checked={TAB_SELECCIONADO === "tab-4_G5" ? "checked" : ""} />
                                                    <span onClick={(e) => { setTAB_SELECCIONADO("tab-4_G5"); }}>{traducirPagina("Modelo").toUpperCase()}</span>

                                                    <input type="radio" id="tab-5_G5" name="tab-effect-3" checked={TAB_SELECCIONADO === "tab-5_G5" ? "checked" : ""} />
                                                    <span onClick={(e) => { setTAB_SELECCIONADO("tab-5_G5"); }}>{traducirPagina("Codigo_motor").toUpperCase()}</span>


                                                    <div className="line ease"></div>

                                                    <div className="tab-content_G5">
                                                        <section id="tab-item-1_G5">
                                                            {estadisticas === null || estadisticas.TALLERES_RANKING === null ?
                                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                                :
                                                                estadisticas.TALLERES_RANKING.length > 0 ?
                                                                    <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                                        <thead>
                                                                            <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                                                <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Taller").toUpperCase()}</th>
                                                                                <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("Consultas").toUpperCase()} </th>

                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {estadisticas.TALLERES_RANKING.map((registro, i) =>
                                                                                <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.TALLERES}</td>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.CONSULTAS}</td>


                                                                                </tr>
                                                                            )
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                    :
                                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                                            }
                                                        </section>

                                                        <section id="tab-item-2_G5">

                                                            {estadisticas === null || estadisticas.FAMILIAS_RANKING === null ?
                                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                                :
                                                                estadisticas.FAMILIAS_RANKING.length > 0 ?
                                                                    <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                                        <thead>
                                                                            <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                                                <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Familia").toUpperCase()}</th>
                                                                                <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("Consultas").toUpperCase()} </th>

                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {estadisticas.FAMILIAS_RANKING.map((registro, i) =>
                                                                                <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.FAMILIA}</td>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.CONSULTAS}</td>


                                                                                </tr>
                                                                            )
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                    :
                                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                                            }

                                                        </section>

                                                        <section id="tab-item-3_G5">
                                                            {estadisticas === null || estadisticas.MARCAS_RANKING === null ?
                                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                                :
                                                                estadisticas.MARCAS_RANKING.length > 0 ?
                                                                    <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                                        <thead>
                                                                            <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                                                <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Marca").toUpperCase()}</th>
                                                                                <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("Consultas").toUpperCase()} </th>

                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {estadisticas.MARCAS_RANKING.map((registro, i) =>
                                                                                <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MARCA}</td>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.CONSULTAS}</td>


                                                                                </tr>
                                                                            )
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                    :
                                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                                            }
                                                        </section>

                                                        <section id="tab-item-4_G5">
                                                            {estadisticas === null || estadisticas.MARCAS_MODELO === null ?
                                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                                :
                                                                estadisticas.MARCAS_MODELO.length > 0 ?
                                                                    <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                                        <thead>
                                                                            <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                                                <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Marca").toUpperCase()}</th>
                                                                                <th style={{ width: '400px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Modelo").toUpperCase()}</th>
                                                                                <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("Consultas").toUpperCase()} </th>

                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {estadisticas.MARCAS_MODELO.map((registro, i) =>
                                                                                <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MARCA}</td>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MODELO}</td>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.CONSULTAS}</td>
                                                                                </tr>
                                                                            )
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                    :
                                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                                            }
                                                        </section>

                                                        <section id="tab-item-5_G5">
                                                            {estadisticas === null || estadisticas.CODIGO_MOTOR === null ?
                                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                                :
                                                                estadisticas.CODIGO_MOTOR.length > 0 ?
                                                                    <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                                                        <thead>
                                                                            <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                                                <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Codigo_motor").toUpperCase()}</th>
                                                                                <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} onClick={(e) => { }}>{traducirPagina("Consultas").toUpperCase()} </th>

                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {estadisticas.CODIGO_MOTOR.map((registro, i) =>
                                                                                <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MATRICULA_CODIGO_MOTOR}</td>
                                                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.CONSULTAS}</td>


                                                                                </tr>
                                                                            )
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                    :
                                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                                            }

                                                        </section>

                                                    </div>
                                                </div>

                                            </>

                    }
                </div>
            </Drawer>


            {/*abrirDetalleMatricula ?
                <FichaDetalleMatricula
                    title={traducirPagina("Historial_matriculas")}
                    ESTADO_FICHA={abrirDetalleMatricula}
                    CERRAR_FICHA={setAbrirDetalleMatricula}
                    REGISTRO={estadisticasMatriculaDetalle}
                    USUARIO={props.USUARIO}
                    SELECCIONADO={estadisticaSeleccionada}
                    FECHA_PARTIDA={fechaPartida}

                >
                </FichaDetalleMatricula>
                :
                null
                */}


            {abrirDetalleConsumo ?
                <FichaDetalleConsumo
                    title={traducirPagina("DETALLES_CONNSUMO")}
                    ESTADO_FICHA={abrirDetalleConsumo}
                    CERRAR_FICHA={setAbrirDetalleConsumo}
                    TIPO={tipoConsumo}
                    RED={props.RED}
                >
                </FichaDetalleConsumo>
                :
                null
            }


            {abrirFichaEstadistica ?
                <FichaHistoricoSocio
                    title={"NEXT ASSIST"}
                    ABRIR_FICHA={abrirFichaEstadistica}
                    CERRAR_FICHA={setAbrirFichaEstadistica}

                    MES={parseInt(convertirAMesACodigo(filtroFecha.MES_SELECCIONADO))}
                    ANYO={parseInt(filtroFecha.ANYO_SELECCIONADO)}
                    ID_SOCIO={parseInt(socioSeleccionado)}
                    REGISTRO_SELECCIONADO={registroSeleccionado}
                    ID_DEPARTAMENTO={parseInt(filtroFecha.ID_DEPARTAMENTO)}

                ></FichaHistoricoSocio>
                :
                null

            }

            {abrirDetalleTareaTecnico ?
                <FichaTecnicoProductivo
                    title={traducirPagina("Tecnico").toUpperCase()}
                    ABRIR_FICHA={abrirDetalleTareaTecnico}
                    CERRAR_FICHA={setAbrirDetalleTareaTecnico}
                    DIA={filtroFecha.DIA_SELECCIONADO}
                    MES={parseInt(convertirAMesACodigo(filtroFecha.MES_SELECCIONADO))}
                    ANYO={parseInt(filtroFecha.ANYO_SELECCIONADO)}
                    REGISTRO_SELECCIONADO={registroDetalleTareaTecnico}
                    ID_SOCIO={parseInt(socioSeleccionado)}
                    ID_DEPARTAMENTO={parseInt(filtroFecha.ID_DEPARTAMENTO)}
                >

                </FichaTecnicoProductivo>
                :
                null
            }


            {
                marcaDetalle &&
                <FichaDetalleMarca
                    title={`${traducirPagina("Historial_marca").toUpperCase()} ${registroMarcaDetalle.MARCA} ${traducirPagina("txt_anyo_marca").toUpperCase()} ${registroMarcaDetalle.ANYO}`}
                    ABRIR_FICHA={marcaDetalle}
                    CERRAR_FICHA={setMarcaDetalle}
                    REGISTROS={registroMarcaDetalle}
                ></FichaDetalleMarca>
            }



        </div>

    )
}



FichaEstadisticaAssist.propTypes = {
    title: PropTypes.string,


    TIPO: PropTypes.string,
    CERRAR: PropTypes.object,
    ABRIR_FICHA: PropTypes.bool,


    ID_USUARIO: PropTypes.number,
    SOCIO: PropTypes.number,
    USUARIO: PropTypes.object,
    RED_SELECCIONADA: PropTypes.object,
    RED: PropTypes.object
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        openDrawerFichaClienteSocio: state.estadoDrawer.openDrawerFichaClienteSocio,
        clienteTallerSeleccionado: state.clienteTallerSeleccionado,
        usuario: state.usuario

    };
}

export default connect(mapStateToProps)(FichaEstadisticaAssist);